<template>
  <div :key="page_key" class="page__flash_sale a-page">
    <div style="background-color:white; padding: 15px; border-radius: 4px; overflow: hidden">
      <div style="display: flex; margin: 0; align-items: center">
        <div style="flex: 1">
          <shop-select v-model="shopee_shop.selected" :shopee_shop_list="shopee_shop.list"
                       :disabled="current_component !== 'list'"></shop-select>
        </div>
        <div v-if="current_component === 'list'" class="text-right"
             style="flex: 1; padding-top: 5px; display: flex; gap: 10px; justify-content: right">
          <el-select size="small" value="" v-model="metrics_period" @change="m__get_flash_sale_metrics()">
            <el-option value="real_time" :label="$t('day.realtime')"></el-option>
            <el-option value="yesterday" :label="$t('day.yesterday')"></el-option>
            <el-option value="past7days" :label="$t('day.past7days')"></el-option>
            <el-option value="past30days" :label="$t('day.past30days')"></el-option>
            <el-option value="month" :label="$t('center.by_month')"></el-option>
          </el-select>
          <el-date-picker
            v-if="metrics_period === 'month'"
            id="date-picker-data-center"
            v-model="selected_month"
            type="month"
            format="MM-yyyy"
            :picker-options="{firstDayOfWeek: 1, disabledDate(time) {return time.getTime() > Date.now()}}"
            :placeholder="$t('select.month')"
            size="small"
            :clearable="false"
            @change="m__get_flash_sale_metrics()"
          >
          </el-date-picker>
          <el-button size="mini" icon="el-icon-plus" type="primary" :loading="loading.time_slot"
                     @click="m__show_create_flash_sale_dialog()">{{ $t('flash_sale.create_new') }}
          </el-button>
        </div>
      </div>

      <div v-if="current_component === 'list'">
        <div style="margin-top: 30px">
          <div style="display: flex; gap: 15px; padding-bottom: 10px;" class="hide-scroll">
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.sales') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ m__calculate(flash_sale_metrics.sales) | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.orders') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ flash_sale_metrics.orders | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('base.buyers') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ flash_sale_metrics.buyers | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.ctr') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ flash_sale_metrics.conversion_rate ? (flash_sale_metrics.conversion_rate * 100).toFixed(2) : 0 }}%
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.product_impressions') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ flash_sale_metrics.product_impression | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.product_clicks') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ flash_sale_metrics.product_clicks | currency }}
              </div>
            </div>
            <div
              style="width: 226px; border: 1px solid #e5e5e5; border-radius: 6px; min-width: 180px; padding: 16px; cursor: pointer">
              <div style="font-size: 14px; color: #333; height: 40px">
                {{ $t('metric.sales_per_buyer') }}
              </div>
              <div style="margin-top: 5px; color: #333; font-size: 22px;">
                {{ m__calculate(flash_sale_metrics.sales_per_buyer) | currency }}
              </div>
            </div>
          </div>
        </div>

        <div style="margin-top: 50px">
          <el-tabs v-model="tab" @tab-click="m__update_tab">
            <el-tab-pane :label="$t('base.all')" name="0" :disabled="!shopee_shop.selected || loading.get_flash_sale">
            </el-tab-pane>
            <el-tab-pane :label="$t('base.ongoing')" name="2" :disabled="!shopee_shop.selected">
            </el-tab-pane>
            <el-tab-pane :label="$t('base.upcoming')" name="1" :disabled="!shopee_shop.selected">
            </el-tab-pane>
            <el-tab-pane :label="$t('base.expired')" name="3" :disabled="!shopee_shop.selected">
            </el-tab-pane>
            <el-tab-pane
              :label="`${$t('flash_sale.saved_file')} (${c__flash_sale_files_filter_list.filter(i => i.shopId === this.shopee_shop.selected).length})`"
              name="4"
              :disabled="!shopee_shop.selected">
            </el-tab-pane>
            <el-tab-pane
              v-if="m__is_fs() || m__is_spoil_ads() || flash_sale_advanced_list.includes($store.state.userInfo.username)"
              :label="`${$t('flash_sale.advanced_saved_file')} (${flash_sale_files_advanced.filter(i => i.shopId === this.shopee_shop.selected).length})`"
              name="5"
              :disabled="!shopee_shop.selected">
            </el-tab-pane>
          </el-tabs>

          <div v-if="['0','1','2','3'].includes(tab)">
            <br>
            <div style="display: flex">
              <div style="flex: auto">
                <strong>{{ $t('select.time_slot') }}</strong> &nbsp;&nbsp;
                <el-date-picker
                  size="mini"
                  v-model="range_0"
                  type="daterange"
                  align="right"
                  :start-placeholder="$t('base.start_time')"
                  :end-placeholder="$t('base.end_time')"
                  :disabled="!shopee_shop.selected || loading.get_flash_sale"
                  @change="m__update_time_range('range_0')">
                </el-date-picker>
                &nbsp;&nbsp;
                <el-dropdown trigger="click" @command="m__handle_multiple_action">
                  <el-button size="mini" icon="el-icon-s-tools"
                             :disabled="!shopee_shop.selected || !c__show_filter_flash_sale_list.filter(i => i.checked).length">
                    {{ $t('base.mass_setup') }}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="1">{{ $t('flash_sale.mass_resume') }}</el-dropdown-item>
                    <el-dropdown-item :command="2">{{ $t('flash_sale.mass_pause') }}</el-dropdown-item>
                    <el-dropdown-item :command="3">{{ $t('flash_sale.mass_delete') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                &nbsp;&nbsp;
                <el-button size="mini" @click="m__show_filter_dialog" :disabled="loading.get_flash_sale">
                  <i class="ti-panel"></i>&nbsp; {{ $t('base.filter') }}
                  <template v-if="flash_sale_filter_2.some(i => i.value)">
                    <strong class="text-success">[ON]</strong>
                  </template>
                  <template v-else>
                    <strong class="text-danger">[OFF]</strong>
                  </template>
                </el-button>
              </div>
              <div style="width: 300px" class="text-right">
                <el-button size="mini" icon="el-icon-refresh" @click="m__update_time_range('range_0')"
                           :disabled="loading.get_flash_sale">
                  {{ $t('base.reload_data') }}
                </el-button>
              </div>
            </div>

            <br>
            <br>
            <br>

            <el-table :data="c__show_display_flash_sale_list" v-loading="loading.get_flash_sale"
                      @sort-change="m__flash_sale_sort_change">
              <el-table-column width="40px">
                <template slot="header" slot-scope="scope">
                  <el-checkbox size="mini" :indeterminate="m__is_indeterminate()" v-bind:value="m__is_checked_all()"
                               @change="m__check_all"></el-checkbox>
                </template>
                <template slot-scope="scope">
                  <el-checkbox size="mini" v-model="scope.row.checked"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.time_slot')" min-width="180px">
                <template slot-scope="scope">
                  <div>
                    {{ m__get_time(scope.row) }}
                  </div>
                  <div style="font-size: 11px; color: #999">
                    ID: {{ scope.row.flash_sale_id }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.products')" width="200px">
                <template slot-scope="scope">
                  <span>{{ $t('flash_sale.enabled_for') }} <span style="color: orangered">{{
                      scope.row.enabled_item_count
                    }}</span></span><br>
                  <span style="color: #999">{{ $t('flash_sale.total_available') }} {{
                      10 - scope.row.enabled_item_count
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.created_at')" min-width="180px">
                <template slot-scope="scope">{{ scope.row.ctime * 1000 | moment('DD-MM-YYYY HH:mm') }}</template>
              </el-table-column>
              <el-table-column :label="$t('base.status')" width="120px">
                <template slot-scope="scope">
                  <div v-if="scope.row.type === 1"
                       class="shopee-tag shopee-tag__information shopee-tag--normal default">
                    {{ $t('base.upcoming') }}
                  </div>
                  <div v-if="scope.row.type === 2"
                       class="shopee-tag shopee-tag__information shopee-tag--normal success">
                    {{ $t('base.ongoing') }}
                  </div>
                  <div v-if="scope.row.type === 3"
                       class="shopee-tag shopee-tag__information shopee-tag--normal invalid">
                    {{ $t('base.expired') }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('flash_sale.enable_disable')" width="100px">
                <template slot-scope="scope">
                  <el-switch
                    :disabled="scope.row.type === 3"
                    v-model="scope.row.status"
                    active-color="#13ce66"
                    inactive-color="#b7b7b7"
                    :active-value="1"
                    :inactive-value="2"
                    @change="m__set_flash_sale_status(scope.row, $event)">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column :label="$t('flash_sale.no_of_reminders_set')" width="120px" prop="remindme_cnt"
                               sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.remindme_cnt || '-' }}
                </template>
              </el-table-column>
              <!--              <el-table-column :label="$t('flash_sale.no_of_product_clicks')" width="120px">-->
              <!--                <template slot-scope="scope">-->
              <!--                  {{ scope.row.click_cnt || '-' }}-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column :label="$t('metric.impressions')" width="120px" prop="product_impression"
                               sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.product_impression || '-' | currency(false) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.clicks')" width="120px" prop="product_clicks" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.product_clicks || '-' | currency(false) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.ctr')" width="120px" prop="product_ctr" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.product_ctr ? `${scope.row.product_ctr}%` : '-' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.orders')" width="120px" prop="orders" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.orders || '-' }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.sales')" width="120px" prop="gmv" sortable="custom">
                <template slot-scope="scope">
                  {{ scope.row.gmv || '-' | currency(false) }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.action')" fixed="right" width="150px">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.type === 1" type="text" size="mini"
                             @click="m__show_edit_component(scope.row)"><strong class="text-warning">{{
                      $t('base.edit')
                    }}</strong>
                  </el-button>
                  <el-button v-if="scope.row.type !== 1" type="text" size="mini"
                             @click="m__show_detail_component(scope.row)">
                    <strong class="text-info">{{ $t('base.see_detail') }}</strong>
                  </el-button>
                  <br v-if="scope.row.type !== 1">
                  <el-button type="text" size="mini" v-if="scope.row.type !== 1"
                             @click="m__show_data_component(scope.row)"><strong
                    class="text-info">{{ $t('base.data') }}</strong>
                  </el-button>
                  <br v-if="scope.row.type === 1">
                  <el-button v-if="scope.row.type === 1" type="text" size="mini"
                             @click="m__delete_flash_sale(scope.row)"
                             :disabled="loading.get_flash_sale"><strong
                    class="text-danger">{{ $t('flash_sale.delete') }}</strong>
                  </el-button>
                  <br>
                  <el-button type="text" size="mini" @click="m__copy_flash_sale(scope.row)">
                    <strong class="text-warning">{{ $t('base.copy_data') }}</strong>
                  </el-button>
                  <br>
                  <el-button type="text" size="mini" @click="m__make_file_flash_sale(scope.row)">
                    <strong class="text-warning">{{ $t('flash_sale.create_file') }}</strong>
                  </el-button>
                  <div style="height: 10px">&nbsp;</div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="flash_sale_filter.current_page" :page-size="flash_sale_filter.page_size"
                           layout="prev, pager, next, total" :total="c__show_filter_flash_sale_list.length"/>
          </div>
          <div v-else-if="tab === '4'">
            <div style="margin-top: 20px; display: flex; align-items: center">
              <div style="width: 500px">
                <el-dropdown trigger="click">
                  <el-button size="mini" :disabled="!c__flash_sale_files_filter_list.filter(i => i.selected).length">
                    {{ $t('base.mass_setup') }}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="m__show_flash_sale_file_products_for_batch_update()">
                      {{ $t('flash_sale.edit_products') }}
                    </el-dropdown-item>
                    <el-dropdown-item divided @click.native="m__batch_update_config_status(1)">
                      {{ $t('flash_sale.enable_auto_config') }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="m__batch_update_config_status(0)">
                      {{ $t('flash_sale.disable_auto_config') }}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="m__mass_delete_flash_sale_files()">
                      {{ $t('base.mass_delete') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>

              </div>
              <div style="flex: 1;" class="text-right">
                <el-input size="mini" :placeholder="$t('flash_sale.search_placeholder')" style="max-width: 250px;"
                          prefix-icon="el-icon-search" v-model="input_keyword" clearable/>
                &nbsp;
                &nbsp;
                <el-button size="mini" type="primary" icon="el-icon-plus"
                           @click="m__show_create_flash_sale_file_dialog">
                  {{ $t('flash_sale.create_file') }}
                </el-button>
              </div>
            </div>
            <br>

            <el-table :data="c__flash_sale_files_filter_list.filter(i => i.shopId === this.shopee_shop.selected)"
                      style="margin-top: 20px">
              <el-table-column width="40px" fixed="left">
                <template slot="header" slot-scope="scope">
                  <el-checkbox v-if="c__flash_sale_files_filter_list.length"
                               size="mini" :indeterminate="file_indeterminate" v-model="file_is_selected_all"
                               @change="m__file_select_all"></el-checkbox>
                </template>
                <template slot-scope="scope">
                  <el-checkbox size="mini" v-model="scope.row.selected" @change="m__file_indeterminate"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.filename')" prop="filename" width="340px">
                <template slot-scope="scope">
                  <div>{{ scope.row.filename }}</div>
                  <div style="font-size: 11px; font-weight: 600">ID: {{ scope.row.id }}</div>
                  <div style="display: flex; gap: 10px; margin-top: 5px">
                    <div v-if="scope.row.auto"
                         :class="scope.row.auto.configStatus === 1 ? 'text-running' : 'text-paused'">
                      <a href="javascript:void(0)">
                        {{ $t('flash_sale.auto_config_message_x', {x: $t(`day.${scope.row.auto.runtime}`)}) }}
                        {{ scope.row.auto.time }}
                      </a>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.created_at')" prop="createdAt">
                <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}</template>
              </el-table-column>
              <el-table-column :label="$t('flash_sale.no_of_product')">
                <template slot-scope="scope">{{ scope.row.products ? scope.row.products.length : 0 }}</template>
              </el-table-column>
              <el-table-column :label="$t('base.shop')">
                <template slot-scope="scope">
                  <template v-if="scope.row.shopId && shopee_shop.list.some(i => i._id === scope.row.shopId)">
                    <a href="javascript:void(0)" @click="m__show_select_shop_dialog(scope.row)">
                      <strong class="text-warning">{{ m__get_shop_name(scope.row) }}</strong>
                    </a>
                  </template>
                  <template v-else>
                    <el-button type="text" size="mini" @click="m__show_select_shop_dialog(scope.row)">
                      <strong class="text-primary">{{ $t('select.shop') }}</strong></el-button>
                  </template>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.action')" width="230px">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="m__show_flash_sale_file_products(scope.row)"
                             :loading="loading.get_products">
                    <strong class="text-warning">{{ $t('base.update_file') }}</strong></el-button>
                  <el-button size="mini" type="text" @click="m__delete_flash_sale_file(scope.row)">
                    <strong class="text-danger">{{ $t('base.delete') }}</strong></el-button>
                  <div style="height: 5px"></div>
                  <el-button size="mini" type="text" @click="m__show_clone_flash_sale_dialog(scope.row)"
                             :loading="loading.get_products">
                    <strong class="text-warning">{{ $t('base.clone_file') }}</strong></el-button>
                  <div style="height: 5px"></div>
                  <el-button type="text" size="mini" @click="m__show_update_auto(scope.row)">
                    <strong class="text-primary">{{ $t('flash_sale.setup_auto_config') }}</strong>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-else-if="tab === '5'">
            <el-row>
              <el-col :sm="12">
                &nbsp;
              </el-col>
              <el-col :sm="12">
                <div class="text-right">
                  <el-input size="mini" :placeholder="$t('input.placeholder')" style="max-width: 250px;"
                            prefix-icon="el-icon-search" v-model="input_keyword" clearable/>
                  &nbsp;
                  &nbsp;
                  <el-button size="mini" type="primary" icon="el-icon-plus"
                             @click="m__show_create_flash_sale_advanced_file_dialog">
                    {{ $t('flash_sale.create_file') }}
                  </el-button>
                </div>
              </el-col>
            </el-row>

            <br>

            <div>
              <strong class="text-danger" style="font-size: 13px">
                * {{ $t('flash_sale.random_message') }}
              </strong>
            </div>

            <br>

            <el-table :data="flash_sale_files_advanced.filter(i => i.shopId === this.shopee_shop.selected)">
              <el-table-column :label="$t('base.filename')" prop="filename" width="200px">
                <template slot-scope="scope">
                  {{ scope.row.filename }} <br>
                  <span style="font-size: 11px; font-weight: 600">ID: {{ scope.row.id }}</span> <br>
                  <span v-if="scope.row.auto" class="text-running">
                    <a href="javascript:void(0)">{{ $t('flash_sale.auto_config_message_2') }}</a>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('flash_sale.enable_auto_config')" prop="createdAt" width="120px">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.automation_enabled"
                             @change="m__update_advanced_automation_enabled(scope.row, $event)"></el-switch>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.created_at')" prop="createdAt">
                <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}</template>
              </el-table-column>
              <el-table-column :label="$t('flash_sale.no_of_product')">
                <template slot-scope="scope">{{ scope.row.products.length }}</template>
              </el-table-column>
              <el-table-column :label="$t('base.shop')">
                <template slot-scope="scope">
                  <template v-if="scope.row.shopId && shopee_shop.list.some(i => i._id === scope.row.shopId)">
                    <a href="javascript:void(0)" @click="m__show_select_shop_dialog(scope.row)">
                      <strong class="text-warning">{{ m__get_shop_name(scope.row) }}</strong>
                    </a>
                  </template>
                  <template v-else>
                    <el-button type="text" size="mini" @click="m__show_select_shop_dialog(scope.row)">
                      <strong class="text-primary">{{ $t('select.shop') }}</strong></el-button>
                  </template>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.action')">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="m__show_flash_sale_file_products(scope.row)"
                             :loading="loading.get_products">
                    <strong class="text-warning">{{ $t('base.update_file') }}</strong></el-button>
                  <el-button size="mini" type="text" @click="m__delete_flash_sale_advanced_file(scope.row)">
                    <strong class="text-danger">{{ $t('base.delete') }}</strong></el-button>
                  <div style="height: 5px"></div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div v-if="current_component === 'create'">
        <Page__FlashSaleCreate :seller="seller"
                               :shop="shop"
                               :time_slots="time_slot_selected"
                               :flash_sale_created="flash_sale_created"
                               :shop_id="shopee_shop.selected"
                               :shopee_id="selected_shop.shop_id"
                               :shops="shopee_shop.list"
                               :copy_from_id="copy_from_id"
                               :loading_get_products="loading.get_product"
                               :product_list="product_list"
                               :item_stock_price_infos="item_stock_price_infos"
                               :model_list="model_list"
                               :selected_product_ids="selected_product_ids"
                               :flash_sale_list="flash_sale_list"
                               @m__back_to_list="m__back_to_list"
                               @m__get_flash_sale_files="m__get_flash_sale_files"
                               @m__get_product="m__get_product(seller, true, false)"></Page__FlashSaleCreate>
      </div>

      <div v-if="current_component === 'edit'">
        <Page__FlashSaleEdit :seller="seller"
                             :shop="shop"
                             :time_slots="time_slot_selected"
                             :shop_id="shopee_shop.selected"
                             :shopee_id="selected_shop.shop_id"
                             :shops="shopee_shop.list"
                             :flash_sale_created="flash_sale_created"
                             :flash_sale="flash_sale_selected"
                             :loading_get_products="loading.get_product"
                             :product_list="product_list"
                             :item_stock_price_infos="item_stock_price_infos"
                             :model_list="model_list"
                             @m__back_to_list="m__back_to_list"
                             @m__get_flash_sale_files="m__get_flash_sale_files"
                             @m__get_product="m__get_product(seller, true, false)"></Page__FlashSaleEdit>
      </div>
      <div v-if="current_component === 'detail'">
        <Page__FlashSaleDetail :seller="seller" :flash_sale="flash_sale_selected" :shop="shop"
                               @m__back_to_list="m__back_to_list"></Page__FlashSaleDetail>
      </div>
      <div v-if="current_component === 'data'">
        <Page__FlashSaleData :seller="seller" :flash_sale="flash_sale_selected" :shop="shop"
                             @m__back_to_list="m__back_to_list"></Page__FlashSaleData>
      </div>
    </div>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale"
               custom-class="no-body">
      <div slot="title" style="min-width: 100vh;">
        <div style="position: relative; height: 100%; padding-bottom: 100px">
          <div style="padding:10px;">
            <p><strong style="font-size: 18px">{{ $t('flash_sale.select_time_slot') }}</strong></p>
            <span style="color: #999">&nbsp;</span>
            <div style="display: flex">
              <div style="width: 58%">
                <el-calendar v-model="value">
                  <template
                    slot="dateCell"
                    slot-scope="{date, data}">
                    <p v-if="m__is_in_time_slot(date)" :class="data.isSelected ? 'is-selected' : ''"
                       style="color: orangered">
                      {{ Math.round(data.day.split('-').slice(2).join('-')) }} {{ ' ✔️' }} <br><br>
                      {{ m__time_slot_number(date) + ` ${$t('base.time_slots')}` }}
                    </p>
                    <p v-else :class="data.isSelected ? 'is-selected' : ''">
                      {{ Math.round(data.day.split('-').slice(2).join('-')) }}
                    </p>
                  </template>
                </el-calendar>
              </div>
              <div style="width: 42%; padding-left: 30px">
                <template v-for="item of time_slot_group">
                  <div style="margin-bottom: 20px">
                    <strong>{{ $t('flash_sale.day') }} {{ item.date }}</strong>
                    <el-table :data="item.data">
                      <el-table-column label="#" width="40px">
                        <template slot="header" slot-scope="scope">
                          <el-checkbox size="mini"
                                       :value="item.data.filter(i => i.checked).length === item.data.length"
                                       @change="(e) => item.data.forEach(i => i.checked = e)">
                          </el-checkbox>
                        </template>
                        <template slot-scope="scope">
                          <div style="height: 30px; padding-top: 3px">
                            <el-checkbox size="mini" v-model="scope.row.checked"
                                         @change="m__time_slot_change"></el-checkbox>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('base.time_slot')">
                        <template slot-scope="scope">
                          <span style="font-size: 13px !important;">{{ m__format_time_slot(scope.row) }}</span><br>
                        </template>
                      </el-table-column>
                      <el-table-column :label="$t('base.product')">
                        <template slot-scope="scope">
                          <span style="font-size: 13px !important;">{{ $t('flash_sale.total_available') }} 10</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div
            style="height: 60px; width: 1200px; position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); z-index: 99999; padding-right: 8px">
            <div
              style="width: 100%; height: 100%; display: flex; align-items: center; background-color: #f1f1f1; justify-content: space-between; padding: 0 10px">
              <div style="font-size: 13px">
                {{ $t('flash_sale.time_slots_selected') }}: {{
                  time_slot_group.reduce((t, i) => t + i.data.filter(ii => ii.checked).length, 0)
                }}/{{ time_slot_group.reduce((t, i) => t + i.data.length, 0) }}
              </div>
              <el-button size="mini" type="primary" icon="el-icon-check" :loading="loading.confirm_create"
                         @click="m__confirm_create_flash_sale">{{ $t('flash_sale.confirm_selected') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.flash_sale_files"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row>
          <el-col :sm="12">
            <strong style="font-size: 14px">{{ $t('flash_sale.saved_file') }}</strong> &nbsp;&nbsp;
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input size="mini" :placeholder="$t('input.placeholder')" style="max-width: 250px;"
                      prefix-icon="el-icon-search" v-model="input_keyword" clearable/>
          </el-col>
        </el-row>
        <el-select v-if="!shopee_shop.selected" size="mini" v-model="selected_shop_id" filterable>
          <el-option :label="$t('shop.all')" :value="''"></el-option>
          <el-option v-for="shop in shopee_shop.list.filter(i => i._id.includes(shopee_shop.selected))"
                     :key="shop._id" :label="shop.username" :value="shop._id"></el-option>
        </el-select>
        <br>
        <br>
        <el-table :data="c__flash_sale_files_filter_list">
          <el-table-column :label="$t('base.filename')" prop="filename">
            <template slot-scope="scope">
              {{ scope.row.filename }} <br>
              <span style="font-size: 11px; font-weight: 600">ID: {{ scope.row.id }}</span> <br>
              <span v-if="scope.row.auto" class="text-running">
                <a href="javascript:void(0)">{{ $t('flash_sale.auto_config_message_2') }}</a>
              </span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.created_at')" prop="createdAt">
            <template slot-scope="scope">{{ scope.row.createdAt | moment('DD-MM-YYYY HH:mm') }}</template>
          </el-table-column>
          <el-table-column :label="$t('flash_sale.no_of_product')">
            <template slot-scope="scope">{{ scope.row.products.length }}</template>
          </el-table-column>
          <el-table-column :label="$t('base.shop')">
            <template slot-scope="scope">
              <template v-if="scope.row.shopId && shopee_shop.list.some(i => i._id === scope.row.shopId)">
                <a href="javascript:void(0)" @click="m__show_select_shop_dialog(scope.row)">
                  <strong class="text-warning">{{ m__get_shop_name(scope.row) }}</strong>
                </a>
              </template>
              <template v-else>
                <el-button type="text" size="mini" @click="m__show_select_shop_dialog(scope.row)">
                  <strong class="text-primary">{{ $t('select.shop') }}</strong></el-button>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="m__show_flash_sale_file_products(scope.row)"
                         :loading="loading.get_products">
                <strong class="text-warning">{{ $t('base.update_file') }}</strong></el-button>
              <el-button size="mini" type="text" @click="m__delete_flash_sale_file(scope.row)">
                <strong class="text-danger">Xóa file</strong></el-button>
              <div style="height: 5px"></div>
              <el-button type="text" size="mini" @click="m__show_update_auto(scope.row)">
                <strong class="text-primary">{{ $t('flash_sale.setup_auto_config') }}</strong>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.select_shop"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('select.shop') }}</p>
        <el-select size="mini" v-model="selected_shop_update" class="full-w" filterable>
          <el-option v-for="shop in shopee_shop.list" :key="shop._id" :label="shop.username"
                     :value="shop._id"></el-option>
        </el-select>

        <div style="margin-top: 20px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.select_shop"
                     @click="m__update_shop_flash_sale_file">
            {{ $t('base.update') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog id="flash_sale_file_products" width="1280px" :close-on-click-modal="false"
               :visible.sync="show_dialog.show_flash_sale_file_products" custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="display: flex; align-items: center; margin-bottom: 20px">
          <div style="flex: 0 1 auto">
            <div>
              <template v-if="update_type === 'single'">
                <strong class="strong-label">{{ $t('base.filename') }}</strong>
                <el-input size="mini" v-model="selected_file_update.filename" style="width: 280px"></el-input>
                &nbsp;&nbsp;
                <el-button size="mini" type="primary" icon="el-icon-edit" @click="m__update_flash_sale_filename">
                  {{ $t('base.edit_filename') }}
                </el-button>
              </template>
              <template v-else>
                <strong class="strong-label">&nbsp;</strong>
              </template>
              <el-button size="mini" type="primary" icon="el-icon-plus"
                         @click="m__show_add_product_to_flash_sale_file_dialog">
                {{ $t('base.add_products') }}
              </el-button>
              <el-button size="mini" type="primary" icon="el-icon-upload"
                         @click="m__show_import_product_dialog">
                {{ $t('base.import_products') }}
              </el-button>
              <el-button type="info" size="mini" icon="el-icon-sort"
                         @click="m__show_change_product_position_dialog('flash_sale_file_product_list')">
                {{ $t('flash_sale.change_product_position') }}
              </el-button>
            </div>
          </div>
          <div style="flex: 1; text-align: right">
            <strong class="strong-label">&nbsp;</strong>
            <el-button v-if="update_type === 'single'" type="primary" size="mini" icon="el-icon-check"
                       @click="m__update_discount_flash_sale_file" :loading="loading.update_discount">
              {{ $t('flash_sale.update_file') }}
            </el-button>
            <el-button v-if="update_type === 'multiple'" type="primary" size="mini" icon="el-icon-check"
                       @click="m__batch_update_discount_flash_sale_file" :loading="loading.update_discount">
              {{ $t('base.mass_update') }}
            </el-button>
          </div>
        </div>

        <div>
          <strong class="text-danger">
            * {{ $t('flash_sale.setup_products_note') }}
          </strong>
        </div>

        <Component_FlashSaleProduct
          :id="'file-sticky'"
          style="margin-top: 10px"
          :seller="seller"
          :shopee_id="selected_shop.shop_id"
          :product_selected_list.sync="flash_sale_file_product_list"
          :flash_sale_created="[]"
          :shop_id="old_shop_id"
          :save_current_product="false"
          :show_enable="false"
          :parent_scroll_id="'#flash_sale_file_products > div'"
          :shop="shop"
          @m__remove_product="m__remove_flash_sale_file_product">
        </Component_FlashSaleProduct>

        <div style="margin-top: 20px" class="text-right">
          <el-button v-if="update_type === 'single'" type="primary" size="mini" icon="el-icon-check"
                     @click="m__update_discount_flash_sale_file" :loading="loading.update_discount">
            {{ $t('flash_sale.update_file') }}
          </el-button>
          <el-button v-if="update_type === 'multiple'" type="primary" size="mini" icon="el-icon-check"
                     @click="m__batch_update_discount_flash_sale_file" :loading="loading.update_discount">
            {{ $t('base.mass_update') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.update_auto"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <br>

        <strong class="strong-label">
          {{ $t('flash_sale.runtime') }}
        </strong>
        <div style="display: flex; flex-direction: column; gap: 10px; margin-top: 15px">
          <el-radio v-model="form_auto.runtime" label="daily">
            <span style="font-size: 12px">{{ $t('day.daily') }}</span>
          </el-radio>
          <el-radio v-model="form_auto.runtime" label="normal">
            <span style="font-size: 12px">{{ $t('day.normal') }}
              <!--({{ $t('flash_sale.exclude_spike_day') }})--></span>
          </el-radio>
          <el-radio v-model="form_auto.runtime" label="spike">
            <span style="font-size: 12px">{{ $t('day.spike') }}
              <!--({{ $t('flash_sale.includes_mini_spike_day') }})--></span>
          </el-radio>
        </div>

        <br>

        <strong class="strong-label">{{ $t('flash_sale.creation_time_slot') }}</strong>
        <el-time-select
          class="full-w"
          v-model="form_auto.time"
          size="mini"
          :picker-options="{start: '00:00',step: '00:30',end: '24:00'}"
          :placeholder="`${$t('base.select')} ${$t('flash_sale.creation_time_slot')}`">
        </el-time-select>

        <br>
        <br>

        <strong class="strong-label">
          {{
            $t('flash_sale.create_before_x_hours', {
              x: form_auto.pre_hour,
              min: 1,
              max: 20
            })
          }}
        </strong>
        <el-input size="mini" v-model="form_auto.pre_hour" type="number" :min="1" :max="20"></el-input>

        <!--        <br>-->
        <!--        <br>-->
        <!--        <br>-->

        <!--        <strong class="text-danger">-->
        <!--          *{{ $t('flash_sale.system_will_create_before_x_hours', {x: form_auto.pre_hour}) }}-->
        <!--        </strong>-->

        <div class="text-right" style="margin-top: 30px">
          <el-button v-if="selected_file_update.auto" type="danger" size="mini" icon="el-icon-delete"
                     @click="m__delete_auto"> {{ $t('base.delete') }}
          </el-button>
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__update_auto"
                     :loading="loading.update_auto"> {{ $t('base.update') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading.get_product"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}
              </strong>
            </p>
            <p v-else>
              <strong style="font-size: 18px">{{ $t('select.products') }}
                <a href="javascript:void(0)" style="font-size: 14px" @click="m__get_product(null, true, false)">
                  ({{ $t('base.update_data') }})
                </a>
              </strong>
            </p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left">
            <template slot="header" slot-scope="scope">
              <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                           @change="m__select_all" :disabled="product_selected_list.length >= 10"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate"
                           :disabled="product_selected_list.length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="420px">
            <template slot-scope="scope">
              <div style="display: flex; gap: 5px; padding-right: 10px; overflow: hidden;">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                     style="width:50px; height: 50px;"> &nbsp;&nbsp;&nbsp;
                <div>
                  <a href="javascript:void(0)"
                     @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.itemid}`, shop)">
                    {{ scope.row.name }}
                  </a>
                  <br>
                  {{ $t('product.id') }}: {{ scope.row.itemid }}
                  <template>
                    &nbsp;
                    {{ $t('base.rating') }}: {{ scope.row.rating }}
                  </template>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} {{ m__currency() }}</template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="add_to_cart_units" width="160px"
                           sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('center.items_sold_30_days')" prop="orders" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.orders | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.sales_30_days')" prop="sales" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.sales | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 15px">
          <el-col :sm="12">
            <el-checkbox size="mini" v-model="product_filter.available">
              {{ $t('flash_sale.show_not_created_only') }}
            </el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ product_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button v-if="select_product_type === 'create_fs_file'" size="mini" type="primary" icon="el-icon-check"
                       @click="m__show_create_flash_sale_filename_dialog"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
            <el-button v-if="select_product_type === 'add_to_fs_file'" size="mini" type="primary" icon="el-icon-check"
                       @click="m__add_product_to_flash_sale"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
            <el-button v-if="select_product_type === 'export_product'" size="mini" type="primary" icon="el-icon-check"
                       @click="m__export_product_file"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title"> {{ $t('flash_sale.filename') }}</p>
        <el-input v-model="filename" size="mini" :placeholder="$t('input.filename')"></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" @click="m__create_flash_sale_file"
                     :loading="loading.create_flash_sale_file"> {{ $t('flash_sale.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- todo: advanced -->
    <el-dialog width="1200px" :close-on-click-modal="false" :visible.sync="show_dialog.create_flash_sale_advanced_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading.get_product"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}
              </strong>
            </p>
            <p v-else>
              <strong style="font-size: 18px">{{ $t('select.products') }}
                <a href="javascript:void(0)" style="font-size: 14px" @click="m__get_product(null, true, false)">
                  ({{ $t('base.update_data') }})
                </a>
              </strong>
            </p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left">
            <template slot="header" slot-scope="scope">
              <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                           @change="m__select_all" :disabled="product_selected_list.length >= 10"></el-checkbox>
            </template>
            <template slot-scope="scope">
              <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate"
                           :disabled="product_selected_list.length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="420px">
            <template slot-scope="scope">
              <div style="display: flex; gap: 5px; padding-right: 10px; overflow: hidden;">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                     style="width:50px; height: 50px;"> &nbsp;&nbsp;&nbsp;
                <div>
                  <a href="javascript:void(0)"
                     @click="open_link_fixed(`https://shopee.com/product-i.${shop.shop_id}.${scope.row.itemid}`, shop)">
                    {{ scope.row.name }}
                  </a>
                  <br>
                  {{ $t('product.id') }}: {{ scope.row.itemid }}
                  <template>
                    &nbsp;
                    {{ $t('base.rating') }}: {{ scope.row.rating }}
                  </template>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} {{ m__currency() }}</template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="add_to_cart_units" width="160px"
                           sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('center.items_sold_30_days')" prop="orders" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.orders | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.sales_30_days')" prop="sales" sortable="custom">
            <template slot-scope="scope">
              {{ scope.row.sales | currency }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 15px">
          <el-col :sm="12">
            <el-checkbox size="mini" v-model="product_filter.available">{{ $t('flash_sale.show_not_created_only') }}
            </el-checkbox>
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span
              style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ product_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-check"
                       @click="m__show_create_flash_sale_advanced_filename_dialog"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false"
               :visible.sync="show_dialog.create_flash_sale_advanced_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title"> {{ $t('flash_sale.filename') }}</p>
        <el-input v-model="filename_advanced" size="mini" :placeholder="$t('input.filename')"></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" @click="m__create_flash_sale_advanced_file"
                     :loading="loading.create_flash_sale_advanced_file"> {{ $t('flash_sale.save_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="500px" :close-on-click-modal="false"
               :visible.sync="show_dialog.copy_flash_sale_selection"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('flash_sale.copy_time_slot') }}</p>
        <div style="height: 20px"></div>
        <el-radio class="radio" v-model="copy_selection_radio" label="1">
          {{ $t('flash_sale.select_time_slot_manually') }}
        </el-radio>
        <div style="height: 2px"></div>
        <el-radio class="radio" v-model="copy_selection_radio" label="2">
          {{ $t('flash_sale.select_time_slot_auto') }}
        </el-radio>
        <br>
        <div class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_copy_flash_sale">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="500px" :close-on-click-modal="false"
               :visible.sync="show_dialog.flash_sale_advanced_config"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">{{ $t('flash_sale.setup_advanced_configuration') }}</p>

        <div style="padding-top: 30px; display: flex; flex-direction: column; gap: 25px;">
          <div>
            <el-switch
              v-model="flash_sale_advanced_config.all"
              active-color="#13ce66"
              inactive-color="#b7b7b7"
              :active-value="1"
              :inactive-value="2"
              @change="m__update_flash_sale_advanced_config('all')">
            </el-switch>&nbsp;
            {{ $t('flash_sale.all_day') }}
          </div>
          <div>
            <el-switch
              v-model="flash_sale_advanced_config.half_1"
              active-color="#13ce66"
              inactive-color="#b7b7b7"
              :active-value="1"
              :inactive-value="2"
              @change="m__update_flash_sale_advanced_config('half_1')">
            </el-switch>&nbsp;
            {{ $t('flash_sale.half_a_day_from') }} 0h - 11h59
          </div>
          <div>
            <el-switch
              v-model="flash_sale_advanced_config.half_2"
              active-color="#13ce66"
              inactive-color="#b7b7b7"
              :active-value="1"
              :inactive-value="2"
              @change="m__update_flash_sale_advanced_config('half_2')">
            </el-switch>&nbsp;
            {{ $t('flash_sale.half_a_day_from') }} 12h - 23h59
          </div>
          <div>
            <el-switch
              v-model="flash_sale_advanced_config.custom"
              active-color="#13ce66"
              inactive-color="#b7b7b7"
              :active-value="1"
              :inactive-value="2"
              @change="m__update_flash_sale_advanced_config('custom')">
            </el-switch>&nbsp;
            {{ $t('flash_sale.custom_time') }}
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-time-select
              style="width: 120px"
              :disabled="flash_sale_advanced_config.custom === 2"
              size="mini"
              v-model="flash_sale_advanced_config.custom_start"
              :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
              :placeholder="$t('base.starting_time')">
            </el-time-select>
            &nbsp;&nbsp;
            <el-time-select
              style="width: 120px"
              :disabled="flash_sale_advanced_config.custom === 2"
              size="mini"
              v-model="flash_sale_advanced_config.custom_end"
              :picker-options="{start: '00:00',step: '00:15',end: '24:00'}"
              :placeholder="$t('base.ending_time')">
            </el-time-select>
          </div>
        </div>

        <div style="padding-top: 30px;" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.flash_sale_advanced_config"
                     @click="m__save_flash_sale_advanced_config">{{ $t('base.save_configuration') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="900px" :close-on-click-modal="false"
               :visible.sync="show_dialog.import_product_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="margin-top: 30px">
          <p class="text-title">{{ $t('flash_sale.download_template_file') }}</p>

          <div style="margin-top: 20px">
            <el-radio v-model="export_product_file_type" label="all">{{ $t('product.all') }}</el-radio>
            <el-radio v-model="export_product_file_type" label="multiple">{{ $t('product.select_multiple') }}</el-radio>
            <el-radio v-model="export_product_file_type" label="current">{{ $t('product.current_list') }}</el-radio>
            <el-button type="primary" size="mini" icon="el-icon-download"
                       :loading="loading.export_product_file" @click="m__show_export_product_dialog">
              {{ $t('flash_sale.download_products_file') }}
            </el-button>
          </div>
        </div>


        <div style="margin-top: 60px; display: flex">
          <div style="flex: 0 1 auto">
            <p class="text-title">{{ $t('flash_sale.import_products') }}</p>

            <el-upload
              style="margin-top: 20px"
              class="upload-demo"
              drag
              action="#"
              :on-change="m__import_product_file">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">{{
                  $t('flash_sale.drag_and_drop_or')
                }}<em>{{ $t('flash_sale.click_to_upload') }}</em></div>
              <div class="el-upload__tip" slot="tip">{{ $t('flash_sale.file_format_required') }}</div>
            </el-upload>
          </div>
          <div style="flex: 1; padding-left: 30px">
            <p class="text-title">{{ $t('base.example') }}</p>

            <div style="margin-top: 20px; font-size: 13px">
              - {{ $t('flash_sale.excel_code_title') }}:
              <div style="margin-top: 10px">
                <pre>{{ $t('flash_sale.excel_code') }}</pre>
              </div>
            </div>
            <div style="margin-top: 20px; font-size: 13px">
              - {{ $t('flash_sale.excel_code_title_2') }}:
              <div style="margin-top: 10px">
                <pre>{{ $t('flash_sale.excel_code_2') }}</pre>
              </div>
            </div>
          </div>
        </div>

        <div v-if="import_product_result_list.length" style="margin-top: 60px">
          <p class="text-title">{{ $t('base.result') }} {{ $t('flash_sale.import_products') }}</p>

          <div style="margin-top: 20px">
            <strong style="font-size: 13px"
                    :class="import_product_result_list.filter(i => !i[i.length - 1]).length === import_product_result_list.length ? 'text-success' : 'text-warning'">
              {{ $t('base.there_are') }} {{
                import_product_result_list.filter(i => !i[i.length - 1]).length
              }}/{{ import_product_result_list.length }}
              {{ $t('flash_sale.variations_uploaded') }}.
            </strong>
          </div>
          <div style="margin-top: 20px">
            <template v-for="item in import_product_result_list.filter(i => i[i.length - 1])">
              <div style="font-size: 13px">
                {{ item[item.length - 1] }}
              </div>
            </template>
          </div>
        </div>

        <div v-if="import_product_result_list.filter(i => !i[i.length - 1]).length" style="margin-top: 60px"
             class="text-center">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="m__add_import_product_result_to_fs_file">
            {{ $t('flash_sale.add_products_to_file') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.clone_flash_sale_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title"> {{ $t('flash_sale.filename') }}</p>
        <el-input v-model="filename" size="mini" :placeholder="$t('input.filename')"></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" @click="m__clone_flash_sale_file" icon="el-icon-check"
                     :loading="loading.clone_flash_sale_file">{{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.filter" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <el-table :data="flash_sale_filter_2">
          <el-table-column :label="$t('base.column')" prop="label">
            <template slot-scope="scope">
              <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{ scope.row.label }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.expression')" prop="expression" width="100px">
            <template slot-scope="scope">
              <el-select class="full-w" size="mini" v-model="scope.row.expression">
                <el-option label=">" value=">"></el-option>
                <el-option label="<" value="<"></el-option>
                <el-option label="=" value="==="></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.value')" prop="value" width="120px">
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.optional')" width="100px" align="right">
            <template slot-scope="scope">
              <div style="height: 3px"></div>
              <el-button size="mini" type="danger"
                         @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
              </el-button>
              <div style="height: 3px"></div>
            </template>
          </el-table-column>
        </el-table>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
            {{ $t('base.delete_filter') }}
          </el-button>
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__start_filter">{{
              $t('base.execute')
            }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog id="select_product_from_flash_sale_files" width="650px" :close-on-click-modal="false"
               :visible.sync="show_dialog.change_product_position"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong class="strong-title">{{ $t('flash_sale.change_product_position') }}</strong>

        <div style="margin-top: 30px; padding-right: 20px">
          <draggable v-model="change_product_position_list" v-bind="dragOptions">
            <transition-group style="display: flex; flex-direction: column; gap: 5px">
              <div v-for="product in change_product_position_list" :key="product.itemid"
                   style="background-color: #fff; cursor: pointer; padding: 10px 5px">
                <div style="display: flex; align-items: center">
                  <div style="width: 35px; height: 35px">
                    <img :src="SHOPEE_IMAGE(product.images.split(',')[0])" alt="logo"
                         style="width:30px; height: 30px;"> &nbsp;&nbsp;&nbsp;
                  </div>
                  <div style="flex: 1; padding: 0 10px">
                    <div style="overflow: hidden">{{ product.name }}</div>
                    <div>SKU: {{ product.sku }} - ID: {{ product.itemid }}</div>
                  </div>
                  <div style="width: 30px">
                    <i class="el-icon-rank" style="font-size: 16px"></i>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>

        <div style="margin-top: 40px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.change_product_position"
                     @click="m__confirm_change_product_position()">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {drop as _drop, orderBy as _orderBy, take as _take, uniqBy as _uniqBy, chunk as _chunk} from 'lodash'
import Page__FlashSaleCreate from './create'
import Page__FlashSaleEdit from './edit'
import Page__FlashSaleDetail from './detail'
import Page__FlashSaleData from './data'
import Component_FlashSaleProduct from './component_product'
import {check_channel, check_feature, show_expr_notification} from '../../addon/check_license'
import {flash_sale_advanced_list} from '../../addon/fixed_list'
import readXlsxFile from 'read-excel-file'
import {get_shop_mixins} from "../../mixins/get_shop";
import {fix_ads_mixins} from "../../mixins/fix_ads";
import draggable from 'vuedraggable'

export default {
  name: 'page__flash_sale',

  mixins: [get_shop_mixins, fix_ads_mixins],

  components: {
    draggable,
    Page__FlashSaleCreate,
    Page__FlashSaleEdit,
    Page__FlashSaleDetail,
    Page__FlashSaleData,
    Component_FlashSaleProduct
  },

  data() {
    return {
      page_key: '',

      form_auto: {
        time: '',
        pre_hour: 6,
        runtime: 'daily'
      },
      selected_shop_id: '',
      selected_shop_update: '',
      selected_file_update: {},
      flash_sale_files: [],
      flash_sale_files_advanced: [],
      product_list: [],
      flash_sale_file_product_list: [],
      flash_sale_file_product_list_save: [],
      old_shop_id: '',
      item_stock_price_infos: [],
      model_list: {},
      product_selected_list: [],
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        available: false
      },
      indeterminate: false,
      is_selected_all: false,

      filename: '',
      filename_advanced: '',

      current_component: 'list',
      value: new Date(),
      loading: {
        get_flash_sale: false,
        time_slot: false,
        confirm_create: false,
        get_products: false,
        select_shop: false,
        update_discount: false,
        update_auto: false,
        get_product: false,
        create_flash_sale_file: false,

        create_flash_sale_advanced_file: false,
        flash_sale_advanced_config: false,

        export_product_file: false,
        import_product_file: false,

        clone_flash_sale_file: false,
        change_product_position: false
      },
      show_dialog: {
        create_flash_sale: false,
        flash_sale_files: false,
        select_shop: false,
        show_flash_sale_file_products: false,
        update_auto: false,
        create_flash_sale_file: false,
        create_flash_sale_filename: false,

        create_flash_sale_advanced_file: false,
        create_flash_sale_advanced_filename: false,
        flash_sale_advanced_config: false,

        copy_flash_sale_selection: false,

        export_product_file: false,
        import_product_file: false,

        clone_flash_sale_file: false,

        filter: false,
        change_product_position: false
      },
      flash_sale_filter: {
        page_size: 10,
        current_page: 0
      },
      tab: '0',
      balance: 0,
      selected_shop: {},
      range_0: [this.dayjs().subtract(10, 'day').startOf('d').toDate(), this.dayjs().add(10, 'day').endOf('d').toDate()],
      // range_0: [this.dayjs().startOf('d').toDate(), this.dayjs().add(10, 'day').endOf('d').toDate()],
      range_1: '',
      range_2: '',
      range_3: '',
      start_time: this.dayjs().subtract(10, 'day').startOf('d').unix(),
      // start_time: this.dayjs().startOf('d').unix(),
      end_time: this.dayjs().add(10, 'day').endOf('d').unix(),
      seller: null,
      flash_sale_list: [],
      time_slot_list: [],
      time_slot_group: [],
      time_slot_selected: [],
      flash_sale_created: [],
      flash_sale_selected: null,
      copy_from_id: null,
      product_sort_option: {
        order: null,
        prop: null
      },
      selected_product_ids: [],

      is_destroyed: false,

      input_keyword: '',

      copy_selection_radio: '1',

      flash_sale_advanced_config: {
        all: 1,
        half_1: 2,
        half_2: 2,
        custom: 2,
        custom_start: '',
        custom_end: ''
      },

      flash_sale_advanced_list,

      select_product_type: 'create_fs_file',

      export_product_file_type: 'all',
      import_product_result_list: [],

      file_indeterminate: false,
      file_is_selected_all: false,

      update_type: 'single',

      metrics_start_time: null,
      metrics_end_time: null,
      metrics_period: 'past7days',
      flash_sale_metrics: {},
      selected_month: new Date(),

      flash_sale_sort_option: {
        order: null,
        prop: null
      },

      flash_sale_filter_2: [
        {
          label: this.$t('flash_sale.no_of_reminders_set'),
          key: 'no_of_reminders_set',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('metric.impressions'),
          key: 'product_impression',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('metric.product_clicks'),
          key: 'product_clicks',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('metric.ctr'),
          key: 'product_ctr',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('metric.orders'),
          key: 'orders',
          checked: true,
          expression: '>',
          value: null
        },
        {
          label: this.$t('metric.sales'),
          key: 'gmv',
          checked: true,
          expression: '>',
          value: null
        },
      ],
      flash_sale_filter_2_clone: null,

      change_product_position_source_key: null,
      change_product_position_list: []
    }
  },

  beforeRouteEnter(to, from, next) {
    if (check_feature('flash_sale') || check_channel('shopee_marketing_fs')) {
      next()
    } else {
      show_expr_notification()
      next('/')
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()

    try {
      if (this.$route.query.product_ids && this.$route.query.product_ids.split(',').length) {
        this.selected_product_ids = this.$route.query.product_ids.split(',')
        if (this.selected_product_ids.length) {
          await this.m__show_create_flash_sale_dialog()
        }
      }
    } catch (e) {
      console.error(e)
    }
  },

  async beforeDestroy() {
    this.is_destroyed = true
  },

  watch: {
    'shopee_shop.selected': function () {
      this.page_key = new Date().getTime()
      this.is_destroyed = true
      this.current_component = 'list'
      this.m__initial_view()
    },

    // 'c__show_display_flash_sale_list': function () {
    //   this.m__update_flash_sale_gmv()
    // }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    },

    c__show_filter_flash_sale_list() {
      let result = []

      if (this.tab === '0') {
        result = this.flash_sale_list
      } else {
        result = this.flash_sale_list.filter(i => i.type === +this.tab)
      }

      if (this.flash_sale_filter_2_clone) {
        for (const item of this.flash_sale_filter_2_clone) {
          if (item.value || (item.expression === '< <' && item.value && item.value2)) {
            result = result.filter(i => {
              const value = item.is_percent === true
                ? i[item.key] * 100
                : i[item.key]

              return item.expression === '< <'
                ? i && eval(`${item.value2} < ${value} && ${value} < ${item.value}`)
                : i && eval(`${value}${item.expression}${item.value}`)
            })
          }
        }
      }

      if (this.flash_sale_sort_option.order) {
        this.flash_sale_sort_option.order === 'ascending' && (result = _orderBy(result, [this.flash_sale_sort_option.prop], ['asc']))
        this.flash_sale_sort_option.order === 'descending' && (result = _orderBy(result, [this.flash_sale_sort_option.prop], ['desc']))
      }

      return result
    },

    c__show_display_flash_sale_list() {
      const limit = this.flash_sale_filter.page_size
      const skip = limit * (this.flash_sale_filter.current_page - 1)
      return _take(_drop(this.c__show_filter_flash_sale_list, skip), limit)
    },

    c__flash_sale_files_filter_list() {
      if (this.selected_shop_id) {
        return this.flash_sale_files
          // .filter(i => i.shopId === this.selected_shop_id)
          .filter(i => this.remove_unicode(JSON.stringify(i)).match(this.input_keyword))
      }
      return this.flash_sale_files.filter(i => this.remove_unicode(JSON.stringify(i)).includes(this.remove_unicode(this.input_keyword)))
    },

    c__product_filter_list() {
      let result = this.product_list

      if (this.product_filter.available) {
        result = result.filter(i => !i.created)
      }

      if (!this.show_dialog.create_flash_sale_file) {
        result = result.filter(i => !this.product_selected_list.find(ii => ii.product.itemid === i.itemid))
      }

      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      // const words = this.remove_unicode(this.product_filter.keyword)
      // return result.filter(item => this.remove_unicode(JSON.stringify({
      //   id: item.itemid,
      //   name: item.name
      // })).includes(words))

      const words = this.remove_unicode(this.product_filter.keyword).split(',')
      const pattern = words.map(w => this.escape_regex(w)).join('|');
      const regex = new RegExp(pattern);

      return result.filter(item => {
        const string = this.remove_unicode(JSON.stringify({
          id: item.itemid,
          name: item.name,
          sku: item
        }))
        return regex.test(string)
      })
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)
      return _take(_drop(this.c__product_filter_list, skip), limit)
    }
  },

  methods: {
    m__swap_product(index, type) {
      if (type === 'up') {
        if (index === 0) return
        const temp = this.change_product_position_list[index]
        this.change_product_position_list[index] = this.change_product_position_list[index - 1]
        this.change_product_position_list[index - 1] = temp
      } else {
        if (index === this.change_product_position_list.length - 1) return
        const temp = this.change_product_position_list[index]
        this.change_product_position_list[index] = this.change_product_position_list[index + 1]
        this.change_product_position_list[index + 1] = temp
      }

      this.change_product_position_list = this.clone(this.change_product_position_list)
    },

    async m__confirm_change_product_position() {
      try {
        await this.$confirm(this.$t('base.update_data_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      this.loading.change_product_position = true

      const sorted_product_list = []
      for (const product of this.change_product_position_list) {
        const product_selected = this[this.change_product_position_source_key].find(i => i.product.itemid === product.itemid)
        if (product_selected) {
          sorted_product_list.push(product_selected)
        }
      }
      this[this.change_product_position_source_key] = sorted_product_list

      this.loading.change_product_position = false
      this.show_dialog.change_product_position = false
    },

    m__show_change_product_position_dialog(source_key) {
      if (!this[source_key]) return

      this.change_product_position_source_key = source_key
      this.change_product_position_list = this[source_key].map(i => i.product)
      this.show_dialog.change_product_position = true
    },

    async m__load_products_sku() {
      const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_all_products', {
        shop_id: this.shop.shop_id
      }, this.cf())

      if (cache_response && cache_response.body && cache_response.body.data) {
        const products = JSON.parse(cache_response.body.data)
        for (const product of products) {
          const product_found = this.product_list.find(i => i.itemid === product.id)
          if (product_found) product_found.sku = product.parent_sku
          if (this.model_list[product.id]) {
            for (const model of product.model_list) {
              const model_found = this.model_list[product.id].find(i => i.modelid === model.id)
              if (model_found) {
                model_found.sku = model.sku
              }
            }
          }
        }
      }
    },

    m__start_filter() {
      let any_change = false
      for (const item of this.flash_sale_filter_2) {
        if (item.value) {
          any_change = true
          break
        }
      }
      if (!any_change) {
        this.flash_sale_filter_2_clone = null
      } else {
        this.flash_sale_filter_2_clone = JSON.parse(JSON.stringify(this.flash_sale_filter_2))
      }
      this.show_dialog.filter = false
    },

    m__delete_filter() {
      this.flash_sale_filter_2.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      this.flash_sale_filter_2_clone = null
      this.show_dialog.filter = false
    },

    m__show_filter_dialog() {
      this.show_dialog.filter = true
    },

    m__flash_sale_sort_change({
                                prop,
                                order
                              }) {
      this.flash_sale_sort_option.order = order
      this.flash_sale_sort_option.prop = prop
    },

    async m__get_flash_sale_metrics() {
      let start_time = null, end_time = null, period = this.metrics_period

      if (period === 'real_time') {
        start_time = this.dayjs().startOf('d').unix()
        end_time = this.dayjs().endOf('h').unix()
      } else if (period === 'yesterday') {
        start_time = this.dayjs().subtract(1, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (period === 'past7days') {
        start_time = this.dayjs().subtract(7, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (period === 'past30days') {
        start_time = this.dayjs().subtract(30, 'd').startOf('d').unix()
        end_time = this.dayjs().startOf('d').unix()
      } else if (period === 'month') {
        start_time = this.dayjs(this.selected_month).startOf('month').unix()
        end_time = this.dayjs(this.selected_month).endOf('month').isAfter(this.dayjs())
          ? this.dayjs().startOf('d').unix()
          : this.dayjs(this.selected_month).endOf('month').add(1, 's').unix()
      }

      const flash_sale_key_metrics_response = await this.seller.flash_sale__key_metrics(start_time, end_time, period)
      console.log('flash_sale_key_metrics_response', flash_sale_key_metrics_response)
      if (flash_sale_key_metrics_response && flash_sale_key_metrics_response.result) {
        this.flash_sale_metrics = {}
        for (const key of Object.keys(flash_sale_key_metrics_response.result)) {
          this.flash_sale_metrics[key] = +flash_sale_key_metrics_response.result[key].value
        }
      }
    },

    async m__batch_update_discount_flash_sale_file() {
      try {
        await this.$confirm(this.$t('flash_sale.update_products_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        this.ntf_w(e)
      }

      this.loading.update_discount = true

      for (const file of this.c__flash_sale_files_filter_list.filter(i => i.selected)) {
        file.products = this.flash_sale_file_product_list.map(i => {
          return {
            productId: i.product.itemid,
            models: JSON.stringify(i.model_list)
          }
        })

        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale', {
          ...file
        }, this.cf())
      }

      await this.m__get_flash_sale_files()
      await this.m__get_flash_sale_advanced_files()

      this.ntf_s(this.$t('base.update_success'))
      this.show_dialog.show_flash_sale_file_products = false
      this.loading.update_discount = false
    },

    m__show_flash_sale_file_products_for_batch_update() {
      if (!this.c__flash_sale_files_filter_list.filter(i => i.selected).length) return

      const [file] = this.c__flash_sale_files_filter_list.filter(i => i.selected && i.shopId === this.shop._id)
      this.m__show_flash_sale_file_products(file, 'multiple')
    },

    async m__batch_update_config_status(status) {
      try {
        await this.$confirm(this.$t('flash_sale.change_config_status_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        this.ntf_w(e)
      }

      for (const item of this.c__flash_sale_files_filter_list.filter(i => i.selected)) {
        if (!item.auto) continue

        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
          flashSaleFileId: item.id,
          mipeeUserId: this.$store.state.userInfo.username,
          time: item.auto.time,
          preHour: item.auto.pre_hour,
          configStatus: status
        }, this.cf())
      }

      await this.m__get_flash_sale_files()
      this.ntf_s(this.$t('base.update_success'))
    },

    m__file_select_all() {
      this.file_indeterminate = false
      if (this.file_is_selected_all) {
        this.c__flash_sale_files_filter_list.forEach(i => {
          i.selected = true
        })
      } else {
        this.flash_sale_files.forEach(i => {
          i.selected = false
        })
      }
    },

    m__file_indeterminate() {
      if (this.flash_sale_files.filter(i => i.selected === true).length === this.flash_sale_files.length) {
        this.file_is_selected_all = true
        this.file_indeterminate = false
      } else if (this.flash_sale_files.filter(i => i.selected === true).length === 0) {
        this.file_is_selected_all = false
        this.file_indeterminate = false
      } else {
        this.file_is_selected_all = false
        this.file_indeterminate = true
      }
    },

    async m__clone_flash_sale_file() {
      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      this.loading.clone_flash_sale_file = true
      try {
        const form = {
          mipeeUserId: this.$store.state.userInfo.username,
          filename: this.filename,
          products: this.selected_file_update.products,
          shopId: this.shopee_shop.selected,
          shopeeId: this.shop.shop_id
        }
        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale', form, this.cf())
        await this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.clone_flash_sale_file = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.clone_flash_sale_file = false
      }
    },

    m__show_clone_flash_sale_dialog(file) {
      this.filename = ''
      this.selected_file_update = file
      this.show_dialog.clone_flash_sale_file = true
    },

    async m__update_advanced_automation_all_day_enabled(data, e) {

    },

    async m__update_advanced_automation_am_enabled(data, e) {

    },

    async m__update_advanced_automation_pm_enabled(data, e) {

    },

    m__add_import_product_result_to_fs_file() {
      const add_product_list = []

      for (const item of this.import_product_result_list) {
        const product = this.product_list.find(i => i.itemid === +item[0])
        if (!product) continue
        console.log('product', product)

        const model = this.model_list[product.itemid].find(i => i.modelid === +item[2])
        if (!model) continue
        console.log('model', model)

        const product_in_file = this.selected_file_update.products.find(i => i.productId === +item[0])
        if (product_in_file) {
          console.log('product_in_file', product_in_file)
          let models_list
          if (product_in_file.models) {
            models_list = JSON.parse(product_in_file.models)
            const model_in_file = models_list.find(i => i.modelid === +item[2])
            if (model_in_file) {
              console.log('model_in_file', model_in_file)
              model_in_file.discount_price = +item[7]
              model_in_file.discount_percent = this.m__calculate(100 - (model_in_file.discount_price * 100 / model_in_file.price))
              model_in_file.quantity = +item[8]
            } else {
              console.log('model_in_file no')
              const model_template = this.clone(model)
              model_template.discount_price = +item[7]
              model_template.discount_percent = this.m__calculate(100 - (model_template.discount_price * 100 / model_template.price))
              model_template.quantity = +item[8]
              models_list.push(model_template)
            }
          } else {
            console.log('product_in_file no models')
            const model_template = this.clone(model)
            model_template.discount_price = +item[7]
            model_template.discount_percent = this.m__calculate(100 - (model_template.discount_price * 100 / model_template.price))
            model_template.quantity = +item[8]
            models_list = [model_template]
          }
          product_in_file.models = JSON.stringify(models_list)
          add_product_list.push(product_in_file)
        } else {
          console.log('product_in_file no')
          const model_template = this.clone(model)
          model_template.discount_price = +item[7]
          model_template.discount_percent = this.m__calculate(100 - (model_template.discount_price * 100 / model_template.price))
          model_template.quantity = +item[8]
          this.selected_file_update.products.push({
            productId: +item[0],
            models: JSON.stringify([model_template])
          })
        }
      }

      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = this.selected_file_update.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          result.push(row)
        }
        return result
      }, [])

      const product_ids = this.selected_file_update.products.map(i => i.productId)
      this.flash_sale_file_product_list = this.flash_sale_file_product_list.sort((a, b) => product_ids.indexOf(a.product.itemid) - product_ids.indexOf(b.product.itemid))

      this.show_dialog.import_product_file = false
    },

    async m__import_product_file(file) {
      this.import_product_result_list = []

      try {
        const raw = await readXlsxFile(file.raw)
        for (const [index, row] of raw.entries()) {
          if (index === 0) continue

          const result = this.clone(row)

          if (!Number(row[7])) {
            result.push(`${this.$t('base.row')} ${index + 1}: ${this.$t('flash_sale.invalid_discount_price')}`)
          } else if (Number(row[6]) && !Number(row[8])) {
            result.push(`${this.$t('base.row')} ${index + 1}: ${this.$t('flash_sale.invalid_quantity')}`)
          } else {
            result.push('')
          }

          this.import_product_result_list.push(result)
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.cannot_import_file'))
      }
    },

    m__show_import_product_dialog() {
      this.import_product_result_list = []
      this.show_dialog.import_product_file = true
    },

    m__show_export_product_dialog() {
      this.select_product_type = 'export_product'
      if (this.export_product_file_type === 'all') {
        this.m__export_product_file()
      }
      if (this.export_product_file_type === 'multiple') {
        this.show_dialog.create_flash_sale_file = true
      }
      if (this.export_product_file_type === 'current') {
        this.m__export_product_file()
      }
    },

    async m__export_product_file() {
      const products = []

      if (this.export_product_file_type === 'all') products.push(...this.product_list)
      if (this.export_product_file_type === 'multiple') products.push(...this.product_list.filter(i => i.selected))
      if (this.export_product_file_type === 'current') products.push(...this.product_list.filter(i => this.flash_sale_file_product_list.find(ii => ii.product.itemid === i.itemid)))

      if (!products.length) {
        this.ntf_w(this.$t('required.select_products'))
        return
      }

      this.loading.export_product_file = true
      const data = [[this.$t('product.id'), this.$t('product.name'), this.$t('product.model_id'), this.$t('product.model_name'), this.$t('product.original_price'), this.$t('product.current_price'), this.$t('product.stock'), `*${this.$t('product.flash_sale_price')}`, `*${this.$t('product.promotion_quantity')}`, `*${this.$t('product.limit')}`, this.$t('base.product_sku'), this.$t('base.model_sku')]]

      for (const product of products) {
        for (const model of this.model_list[product.itemid]) {
          const row = [product.itemid.toString(), product.name, model.modelid.toString(), model.name || '-', +model.price, +model.promotionPrice || +model.price, +model.stock, null, null, 0, product.sku || '-', model.sku || '-']
          data.push(row)
        }
      }

      const filename = `flash_sale-products-shop-${this.shop.username}-${this.dayjs().format('DDMMYYYY-HHmm')}.xlsx`
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/export_excel', {
        data: data,
        filename: filename
      }, {
        ...this.cf(),
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()

      this.ntf_s(this.$t('product.download_file_success'))
      this.loading.export_product_file = false
      this.show_dialog.create_flash_sale_file = false
    },

    m__add_product_to_flash_sale() {
      this.flash_sale_file_product_list_save = this.product_list.filter(i => i.selected).map(i => ({product: i}))
      for (const product of this.flash_sale_file_product_list_save) {
        const found = this.selected_file_update.products.find(i => i.productId === product.product.itemid)
        if (found) continue

        this.selected_file_update.products.push({
          productId: product.product.itemid,
          models: JSON.stringify(product.model_list)
        })
      }

      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = this.selected_file_update.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          result.push(row)
        }
        return result
      }, [])

      const product_ids = this.selected_file_update.products.map(i => i.productId)
      this.flash_sale_file_product_list = this.flash_sale_file_product_list.sort((a, b) => product_ids.indexOf(a.product.itemid) - product_ids.indexOf(b.product.itemid))

      this.show_dialog.create_flash_sale_file = false
    },

    m__show_add_product_to_flash_sale_file_dialog() {
      this.select_product_type = 'add_to_fs_file'
      this.show_dialog.create_flash_sale_file = true
    },

    async m__save_flash_sale_advanced_config() {
      if (this.flash_sale_advanced_config.custom === 1 && !this.flash_sale_advanced_config.custom_start) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }
      if (this.flash_sale_advanced_config.custom === 1 && !this.flash_sale_advanced_config.custom_start) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      this.show_dialog.flash_sale_advanced_config = false
      this.ntf_s(this.$t('base.update_success'))
    },

    m__update_flash_sale_advanced_config(_key) {
      for (const key of Object.keys(this.flash_sale_advanced_config)) {
        if (['custom_start', 'custom_end'].includes(key)) continue

        if (key === _key) {
          this.flash_sale_advanced_config[key] = 1
        } else {
          this.flash_sale_advanced_config[key] = 2
        }
      }
    },

    m__show_flash_sale_advanced_config_dialog() {
      this.show_dialog.flash_sale_advanced_config = true
    },

    m__is_spoil_ads() {
      const pack = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing')
      return pack && pack.package && pack.package.extra_data && pack.package.extra_data.marketing && pack.package.extra_data.marketing.spoil_ads
    },

    m__is_fs() {
      const agency = this.$store.state.package && this.$store.state.package.extend_package && this.$store.state.package.extend_package.find(i => i.package && i.package.channel === 'shopee_marketing_fs')
      if (agency) {
        return this.dayjs().isBefore(this.dayjs(new Date(agency.license_to)), 's')
      } else {
        return false
      }
    },

    async m__update_flash_sale_filename() {
      if (!this.selected_file_update || !this.selected_file_update.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      try {
        await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/filename', {
          ...this.selected_file_update
        }, this.cf())

        await this.m__get_flash_sale_files()
        await this.m__get_flash_sale_advanced_files()

        this.ntf_s(this.$t('base.update_success'))
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('base.has_an_occurred'))
      }
    },

    async m__update_flash_sale_gmv() {
      for (const item of this.flash_sale_list) {
        if (!item.loaded) {
          // const response = await this.seller.flash_sale_get_product_ranking(item.flash_sale_id, item.type === 3)

          let response
          const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get', {
            data_id: item.flash_sale_id,
            type: 'flash_sale_product_ranking',
            shop_id: this.shop.shop_id
          }, this.cf())
          if (cache_response && cache_response.body && cache_response.body.data) {
            response = typeof cache_response.body.data === 'string' ? JSON.parse(cache_response.body.data) : cache_response.body.data
          } else {
            await this.sleep(500)
            response = await this.seller.flash_sale_get_product_ranking(item.flash_sale_id, item.type === 3)
          }
          if (response && response.result) {
            item.gmv = response.result.reduce((t, i) => t + this.m__calculate(i.sales), 0)
            item.orders = response.result.reduce((t, i) => t + i.orders, 0)
            item.product_impression = response.result.reduce((t, i) => t + i.product_impression, 0)
            item.product_clicks = response.result.reduce((t, i) => t + i.product_clicks, 0)
            item.product_ctr = item.product_impression ? parseFloat((item.product_clicks * 100 / item.product_impression).toFixed(2)) : 0
            item.loaded = true
          }
        }
      }
    },

    async m__handle_multiple_action(command) {
      if (command === 1) await this.m__multiple_enable_flash_sale()
      if (command === 2) await this.m__multiple_disable_flash_sale()
      if (command === 3) await this.m__multiple_delete_flash_sale()
    },

    async m__multiple_enable_flash_sale() {
      try {
        await this.$confirm(this.$t('flash_sale.enable_time_slots_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      for (const item of this.c__show_filter_flash_sale_list.filter(i => i.checked)) {
        if (item.status === 2) {
          item.status = 1
          await this.seller.flash_sale_set_status(item.flash_sale_id, item.timeslot_id, 1)
        }
      }
    },

    async m__multiple_disable_flash_sale() {
      try {
        await this.$confirm(this.$t('flash_sale.disable_time_slots_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      for (const item of this.c__show_filter_flash_sale_list.filter(i => i.checked)) {
        if (item.status === 1) {
          item.status = 2
          await this.seller.flash_sale_set_status(item.flash_sale_id, item.timeslot_id, 2)
        }
      }
    },

    async m__multiple_delete_flash_sale() {
      try {
        await this.$confirm(this.$t('flash_sale.mass_delete_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })
      } catch (e) {
        return
      }

      for (const item of this.c__show_filter_flash_sale_list.filter(i => i.checked)) {
        if (item.status !== 3) {
          await this.seller.flash_sale_delete(item.flash_sale_id, item.timeslot_id)
        }
      }

      const start_time = this.dayjs().unix()
      const end_time = this.dayjs().add(30, 'd').unix()
      await this.seller.flash_sale_get_time_slot(start_time, end_time)

      this.ntf_s(this.$t('base.update_success'))
      await this.m__get_flash_sale()
    },

    async m__set_flash_sale_status(flash_sale, value) {
      if (value === 2) {
        try {
          await this.$confirm(this.$t('flash_sale.disable_time_slots_confirm'), this.$t('base.attention'), {
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel'),
            type: 'warning'
          })
        } catch (e) {
          flash_sale.status = 1
          return
        }
      }

      await this.seller.flash_sale_set_status(flash_sale.flash_sale_id, flash_sale.timeslot_id, value)
    },

    m__is_checked_all() {
      return this.c__show_filter_flash_sale_list.length && this.c__show_filter_flash_sale_list.length === this.c__show_filter_flash_sale_list.filter(i => i.checked).length
    },

    m__is_indeterminate() {
      return this.c__show_filter_flash_sale_list.some(i => i.checked) && !this.m__is_checked_all()
    },

    m__check_all(e) {
      for (const item of this.c__show_filter_flash_sale_list) {
        item.checked = e
      }
    },

    async m__update_advanced_automation_enabled(data, e) {
      if (e === true) {
        for (const item of this.flash_sale_files_advanced.filter(i => i.shopId === this.shopee_shop.selected)) {
          item.automation_enabled = false
        }

        data.automation_enabled = true
      }

      for (const item of this.flash_sale_files_advanced.filter(i => i.shopId === this.shopee_shop.selected)) {
        try {
          await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale/advanced/update_automation_enabled', {
            id: item.id,
            value: item.automation_enabled,
            mipeeUserId: this.$store.state.userInfo.username
          }, this.cf())
        } catch (e) {
          console.error(e)
        }
      }

      this.ntf_s(this.$t('base.update_success'))
    },

    async m__delete_flash_sale_advanced_file(item) {
      try {
        await this.$confirm(this.$t('flash_sale.delete_file_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/flash_sale/advanced', {
          ...this.cf(),
          params: {
            mipeeUserId: this.$store.state.userInfo.username,
            flashSaleFileId: item.id
          }
        })
        await this.m__get_flash_sale_advanced_files()
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      }
    },

    async m__get_flash_sale_advanced_files() {
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale/advanced', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shop._id,
          shopeeId: this.shop.shop_id
        }
      })
      this.flash_sale_files_advanced = resp.data
    },

    m__show_create_flash_sale_advanced_file_dialog() {
      // this.show_dialog.create_flash_sale_advanced_file = true
      this.m__show_create_flash_sale_advanced_filename_dialog()
    },

    m__show_create_flash_sale_advanced_filename_dialog() {
      this.filename_advanced = ''
      this.flash_sale_file_product_list_save = this.product_list.filter(i => i.selected).map(i => ({product: i}))
      this.show_dialog.create_flash_sale_advanced_filename = true
    },

    async m__create_flash_sale_advanced_file() {
      if (!this.filename_advanced) {
        this.ntf_w(this.$t('required.filename'))
        return
      }

      // if (!this.flash_sale_file_product_list_save.length) {
      //   this.ntf_w(this.$t('required.select_products'))
      //   return
      // }

      const form = {
        mipeeUserId: this.$store.state.userInfo.username,
        filename: this.filename_advanced,
        products: this.flash_sale_file_product_list_save.map(i => ({
          productId: i.product.itemid,
          models: JSON.stringify(i.model_list)
        })),
        shopId: this.shopee_shop.selected,
        shopeeId: this.shop.shop_id,
        automation_enabled: false
      }

      try {
        this.loading.create_flash_sale_advanced_file_file = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale/advanced', form, this.cf())
        await this.m__get_flash_sale_advanced_files()
        this.ntf_s(this.$t('base.save_success'))
        this.show_dialog.create_flash_sale_advanced_filename = false
        this.show_dialog.create_flash_sale_advanced_file = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.create_flash_sale_advanced_file = false
      }
    },

    async m__make_file_flash_sale(flash_sale) {
      // if (flash_sale.enabled_item_count === 0) {
      //   return
      // }

      const resp = await this.seller.flash_sale_get_item_ids(flash_sale.flash_sale_id)
      const item_ids = resp.data.item_ids

      const batch_items = []
      let offset = 0, limit = 100, count = 0
      let batch_resp = await this.seller.flash_sale_get_batch_items(flash_sale.flash_sale_id, offset, limit)
      while (batch_resp.data.items && batch_resp.data.items.length) {
        batch_items.push(...batch_resp.data.items)
        for (const item of batch_resp.data.items) {
          const item_found = batch_resp.data.price_stock_info.find(i => i.item_id === item.item_id)
          const model_found = item_found.sku_stock_price_list.find(i => i.model_id === item.model_id)
          item.price = model_found.price_info.normal_price
          item.quantity = model_found.seller_stock_info.normal_stock
        }

        count += batch_resp.data.item_info.length
        if (count >= batch_resp.data.total_count) break

        offset += limit
        batch_resp = await this.seller.flash_sale_get_batch_items(flash_sale.flash_sale_id, offset, limit)
      }

      this.flash_sale_file_product_list_save = []
      for (const item_id of item_ids) {
        const product = this.product_list.find(i => i.itemid === item_id)
        if (product) {
          this.flash_sale_file_product_list_save.push({
            product: this.clone(product),
            // item_stock_price_infos: this.item_stock_price_infos.find(i => i.item_id === product.itemid),
            model_list: this.clone(this.model_list)[product.itemid].map(i => {
              const batch = batch_items.find(ii => ii.model_id === i.modelid)
              if (batch) {
                product.limit = batch.purchase_limit > 0 ? 1 : 0
                product.limit_value = batch.purchase_limit
                i.stock = batch.quantity + batch.stock
                i.quantity = batch.stock
                i.discount_price = batch.promotion_price
                i.discount_percent = this.m__calculate(100 - (i.discount_price * 100 / i.price))
                i.enable = false
                i.checked = false
              }
              return i
            })
          })
        }
      }

      this.filename = ''
      this.show_dialog.create_flash_sale_filename = true
    },

    m__select_all() {
      this.indeterminate = false
      if (this.is_selected_all) {
        this.c__product_filter_list.forEach(i => {
          i.selected = true
        })
      } else {
        this.product_list.forEach(i => {
          i.selected = false
        })
      }
    },

    m__indeterminate() {
      if (this.product_list.filter(i => i.selected === true).length === this.product_list.length) {
        this.is_selected_all = true
        this.indeterminate = false
      } else if (this.product_list.filter(i => i.selected === true).length === 0) {
        this.is_selected_all = false
        this.indeterminate = false
      } else {
        this.is_selected_all = false
        this.indeterminate = true
      }
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    },

    m__show_create_flash_sale_file_dialog() {
      // this.select_product_type = 'create_fs_file'
      // this.show_dialog.create_flash_sale_file = true

      this.m__show_create_flash_sale_filename_dialog()
    },

    m__show_create_flash_sale_filename_dialog() {
      this.filename = ''
      this.flash_sale_file_product_list_save = this.product_list.filter(i => i.selected).map(i => ({product: i}))
      this.show_dialog.create_flash_sale_filename = true
    },

    async m__create_flash_sale_file() {
      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
        return
      }
      // if (!this.flash_sale_file_product_list_save.length) {
      //   this.ntf_w(this.$t('required.select_products'))
      //   return
      // }

      const form = {
        mipeeUserId: this.$store.state.userInfo.username,
        filename: this.filename,
        products: this.flash_sale_file_product_list_save.map(i => ({
          productId: i.product.itemid,
          models: JSON.stringify(i.model_list)
        })),
        shopId: this.shopee_shop.selected,
        shopeeId: this.shop.shop_id
      }

      try {
        this.loading.create_flash_sale_file = true
        await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale', form, this.cf())
        await this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.save_success'))
        this.show_dialog.create_flash_sale_filename = false
        this.show_dialog.create_flash_sale_file = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.create_flash_sale_file = false
      }
    },

    async m__get_product(seller = null, performance = false, use_cache = true) {
      if (!seller || !seller.username) seller = this.seller

      try {
        this.loading.get_product = true
        this.product_selected_list = []
        this.product_list = []
        this.model_list = {}

        const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_marketing_products', {
          shop_id: this.shop.shop_id
        }, this.cf())
        console.log('cache_response', cache_response)

        const product_cache_list = cache_response && cache_response.body && cache_response.body.data && cache_response.body.data.length
          ? typeof cache_response.body.data === 'string' ? JSON.parse(cache_response.body.data) : cache_response.body.data
          : []

        // todo: test
        use_cache = false

        if (use_cache && product_cache_list.length > 300) {
          const chunk_list = _chunk(product_cache_list, 50)
          for (const chunk of chunk_list) {
            if (this.is_destroyed) return

            const product_detail_list = []
            const product_ids = chunk.map(i => i.itemid.toString())

            // todo: get cache data
            const products_by_graphql_cache_cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_products_by_graphql', {
              shop_id: this.shop.shop_id,
              product_ids: product_ids
            }, this.cf())
            if (products_by_graphql_cache_cache_response && products_by_graphql_cache_cache_response.body && products_by_graphql_cache_cache_response.body.data) {
              const data = typeof products_by_graphql_cache_cache_response === 'string'
                ? JSON.parse(products_by_graphql_cache_cache_response.body.data)
                : products_by_graphql_cache_cache_response.body.data
              product_detail_list.push(...data.map(i => JSON.parse(i.response)))
            }

            // todo: get missing cache data
            if (product_detail_list.length < chunk.length) {
              const founded_product_ids_set = new Set(product_detail_list.map(i => i.itemid.toString()))
              const missing_product_id = chunk.filter(i => !founded_product_ids_set.has(i.itemid.toString())).map(i => i.itemid.toString())
              const products_detail = await seller.get_product_by_graphql(missing_product_id)
              if (products_detail && products_detail.data && products_detail.data.products && products_detail.data.products.items) {
                product_detail_list.push(...products_detail.data.products.items)
              }
            }
            // console.log('product_detail_list', product_detail_list)

            for (const item of product_detail_list) {
              const product_model = {}
              product_model[+item.itemid] = item.modelList.map(i => {
                i.modelid = +i.modelid
                i.price = +i.originPrice
                i.stock = +i.normalStock
                i.checked = false
                i.enable = false
                i.discount_price = i.price
                i.discount_percent = 0
                i.quantity = i.stock
                i.message = ''
                i.error_message = ''
                i.sku = ''
                i.misleading = false
                return i
              })
              Object.assign(this.model_list, product_model)
            }

            for (const i of chunk) {
              i.selected = false
              i.checked = false
              i.limit = 0
              i.limit_value = 100
              i.enable = false
              i.error_message = ''
              i.revenue = i.price * i.sold
              i.add_to_cart_units = 0
              i.orders = 0
              i.sales = 0
              i.rating = 0
              i.created = false
              i.sku = ''
              i.misleading = false
            }
            this.product_list.push(...chunk)
          }

          console.log('loaded products from cache')
        } else {
          let offset = 0, limit = 50
          let product_response = await seller.flash_sale_get_product(offset, limit)

          while (product_response.data.item_list && product_response.data.item_list.length) {
            if (this.is_destroyed) return

            const products_detail = await seller.get_product_by_graphql(product_response.data.item_list.map(i => i.itemid.toString()))
            for (const item of products_detail.data.products.items) {
              const product_model = {}
              product_model[+item.itemid] = item.modelList.map(i => {
                i.modelid = +i.modelid
                i.price = +i.originPrice
                i.stock = +i.normalStock
                i.checked = false
                i.enable = false
                i.discount_price = i.price
                i.discount_percent = 0
                i.quantity = i.stock
                i.message = ''
                i.error_message = ''
                i.sku = ''
                i.misleading = false
                return i
              })
              Object.assign(this.model_list, product_model)
            }

            for (const i of product_response.data.item_list) {
              i.selected = false
              i.checked = false
              i.limit = 0
              i.limit_value = 100
              i.enable = false
              i.error_message = ''
              i.revenue = i.price * i.sold
              i.add_to_cart_units = 0
              i.orders = 0
              i.sales = 0
              i.rating = 0
              i.created = false
              i.sku = ''
              i.misleading = false
            }
            this.product_list.push(...product_response.data.item_list)

            offset += limit
            product_response = await seller.flash_sale_get_product(offset, limit)
          }
        }

        this.product_list = _orderBy(this.product_list, ['revenue'], ['desc'])

        this.m__load_products_sku()
          .catch(console.error)

        this.m__get_product_not_created(seller)
          .catch(console.error)

        if (performance) {
          this.is_destroyed = true
          this.is_destroyed = false
          this.m__get_product_performance(seller)
            .catch(console.error)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_product = false
      }
    },

    async m__get_product_not_created(seller) {
      while (this.loading.get_flash_sale) {
        await this.sleep(1000)
      }

      const filter_flash_sale_list = this.flash_sale_list.filter(i => i.type === 1 || i.type === 2)
      for (const item of filter_flash_sale_list) {
        // this.loading.get_product = true
        const resp = await seller.flash_sale_get_item_ids(item.flash_sale_id)
        if (resp && resp.data && resp.data.item_ids) {
          // console.log(resp.data.item_ids)
          for (const id of resp.data.item_ids) {
            const product_found = this.product_list.find(i => i.itemid === id)
            if (product_found) product_found.created = true
          }
        }
      }

      this.loading.get_product = false
    },

    async m__get_product_performance(seller) {
      try {
        const cache_response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/cache/get_shopee_ads_products', {
          shop_id: this.shop.shop_id
        }, this.cf())
        if (cache_response && cache_response.body && cache_response.body.data) {
          const product_cache_list = typeof cache_response.body.data === 'string'
            ? JSON.parse(cache_response.body.data)
            : cache_response.body.data

          for (const product of product_cache_list) {
            const product_found = this.product_list.find(i => i.itemid === product.item_id)
            if (product_found) product_found.rating = parseFloat(product.rating.toFixed(1))
          }
        }

        let page = 1, page_size = 20
        const start_time = this.dayjs().subtract(30, 'days').startOf('d').unix()
        const end_time = this.dayjs().startOf('d').unix()
        let product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')

        const performance_list = []
        while (!this.is_destroyed && this.seller && seller && this.seller.username === seller.username &&
        product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
        product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
          // this.loading.get_product = true

          performance_list.push(...product_performance_resp.data.result.items)
          if (performance_list.length > product_performance_resp.data.result.total) {
            break
          }

          for (const product of product_performance_resp.data.result.items) {
            const product_found = this.product_list.find(i => i.itemid === product.id)
            if (product_found) {
              product_found.add_to_cart_units = product.add_to_cart_units || 0
              product_found.orders = product.placed_units || 0
              product_found.sales = this.seller.m__calculate(product.placed_sales)
            }
          }

          await this.sleep(1000)
          page++
          product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')
        }
      } catch (e) {
      } finally {
        this.loading.get_product = false
      }
    },

    m__show_update_auto(item) {
      if (!item.shopId) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      if (item.auto) {
        this.form_auto.time = item.auto.time
        this.form_auto.pre_hour = item.auto.preHour || 6
        this.form_auto.runtime = item.auto.runtime || 'daily'
      }

      this.selected_file_update = item
      this.show_dialog.update_auto = true
    },

    async m__update_auto() {
      if (!this.form_auto.pre_hour) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      if (!this.form_auto.time) {
        this.ntf_w(this.$t('required.full_data'))
        return
      }

      this.loading.update_auto = true

      await this.$http.post(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
        flashSaleFileId: this.selected_file_update.id,
        mipeeUserId: this.$store.state.userInfo.username,
        time: this.form_auto.time,
        preHour: this.form_auto.pre_hour,
        runtime: this.form_auto.runtime
      }, this.cf())

      await this.m__get_flash_sale_files()

      this.ntf_s(this.$t('base.save_success'))

      this.loading.update_auto = false
      this.show_dialog.update_auto = false
    },

    async m__delete_auto() {
      try {
        await this.$confirm(this.$t('base.delete_config_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        await this.$http.delete(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
          ...this.cf(),
          params: {
            flashSaleFileId: this.selected_file_update.id,
            mipeeUserId: this.$store.state.userInfo.username
          }
        })
        this.selected_file_update.auto = null
        this.ntf_s(this.$t('base.delete_success'))
        this.show_dialog.update_auto = false
      } catch (e) {

      }
    },

    async m__update_discount_flash_sale_file() {
      this.loading.update_discount = true

      this.selected_file_update.products = this.flash_sale_file_product_list.map(i => {
        return {
          productId: i.product.itemid,
          models: JSON.stringify(i.model_list)
        }
      })

      try {
        if (this.selected_file_update.isAdvanced) {
          await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/advanced', {
            ...this.selected_file_update
          }, this.cf())
        } else {
          await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/filename', {
            ...this.selected_file_update
          }, this.cf())
          await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale', {
            ...this.selected_file_update
          }, this.cf())
        }

        await this.m__get_flash_sale_files()
        await this.m__get_flash_sale_advanced_files()

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.show_flash_sale_file_products = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.update_discount = false
      }
    },

    async m__update_shop_flash_sale_file() {
      if (!this.selected_shop_update || !this.selected_file_update.id) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      this.loading.select_shop = true
      try {
        if (this.selected_file_update.isAdvanced) {
          await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale/advanced', {
            ...this.selected_file_update,
            shopId: this.selected_shop_update,
            shopeeId: this.shop.shop_id
          }, this.cf())
        } else {
          await this.$http.put(this.API.URL_API_SRV_1 + '/flash_sale', {
            ...this.selected_file_update,
            shopId: this.selected_shop_update,
            shopeeId: this.shop.shop_id
          }, this.cf())
        }

        await this.m__get_flash_sale_files()
        await this.m__get_flash_sale_advanced_files()

        this.ntf_s(this.$t('base.update_success'))
        this.show_dialog.select_shop = false

        this.selected_file_update.shopId = this.selected_shop_update
        await this.m__get_flash_sale_files()
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.select_shop = false
      }
    },

    async m__remove_flash_sale_file_product(item) {
      if (item) {
        try {
          await this.$confirm(this.$t('base.delete_product_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
          this.flash_sale_file_product_list = this.flash_sale_file_product_list.filter(i => i.product.itemid !== item.product.itemid)
        } catch (e) {
        }
      } else {
        try {
          await this.$confirm(this.$t('base.delete_all_product_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
          this.flash_sale_file_product_list = []
        } catch (e) {
        }
      }
    },

    m__get_shop_name(data) {
      if (data.shopId) {
        const found = this.shopee_shop.list.find(i => i._id === data.shopId)
        return found ? found.username : ''
      }
      return ''
    },

    m__show_select_shop_dialog(data) {
      this.selected_shop_update = data.shopId
      this.selected_file_update = data
      this.show_dialog.select_shop = true
    },

    async m__get_flash_sale_files() {
      this.file_is_selected_all = false
      this.file_indeterminate = false

      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shop._id,
          shopeeId: this.shop.shop_id
        }
      })
      const resp_auto = await this.$http.get(this.API.URL_API_SRV_1 + '/flash_sale/auto', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shop._id,
          shopeeId: this.shop.shop_id
        }
      })
      for (const item of resp.data) {
        item.selected = false
        item.auto = resp_auto.data.find(i => i.flashSaleFileId === item.id)
      }
      this.flash_sale_files = resp.data
    },

    async m__show_flash_sale_file_products(file, update_type = 'single') {
      this.update_type = update_type

      if (!file.shopId) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      const shop = this.shopee_shop.list.find(i => i._id === file.shopId)
      if (!shop) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      this.selected_file_update = file
      this.loading.get_products = true

      const seller = await this.init_seller(shop)

      if (shop._id !== this.old_shop_id && shop._id !== this.shopee_shop.selected) {
        await this.m__get_product(seller, false)
      }
      this.old_shop_id = shop._id

      while (this.loading.get_product) {
        await this.sleep(1000)
      }

      this.flash_sale_file_product_list = this.product_list.reduce((result, product) => {
        const product_found = file.products.find(i => i.productId === product.itemid)
        if (product_found) {
          const row = {
            product: product,
            model_list: product_found.models
              ? JSON.parse(product_found.models).map(model => {
                const model_found = this.clone(this.model_list[product.itemid]).find(i => i.modelid === model.modelid)
                if (model_found) {
                  model.name = model.name || ''
                  model.price = model_found.price
                  model.stock = model_found.stock
                }
                return model
              })
              : this.clone(this.model_list[product.itemid])
          }
          result.push(row)
        }
        return result
      }, [])

      const product_ids = file.products.map(i => i.productId)
      this.flash_sale_file_product_list = this.flash_sale_file_product_list.sort((a, b) => product_ids.indexOf(a.product.itemid) - product_ids.indexOf(b.product.itemid))

      this.show_dialog.show_flash_sale_file_products = true
      this.loading.get_products = false
    },

    async m__mass_delete_flash_sale_files() {
      try {
        await this.$confirm(this.$t('flash_sale.delete_files_confirm'), this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
      } catch (e) {
        return
      }

      for (const item of this.c__flash_sale_files_filter_list.filter(i => i.selected)) {
        await this.m__delete_flash_sale_file(item, false)
      }

      await this.m__get_flash_sale_files()
      this.ntf_s(this.$t('base.delete_success'))
    },

    async m__delete_flash_sale_file(item, show_confirm = true) {
      if (show_confirm) {
        try {
          await this.$confirm(this.$t('flash_sale.delete_file_confirm'), this.$t('base.attention'), {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
        } catch (e) {
          return
        }
      }

      await this.$http.delete(this.API.URL_API_SRV_1 + '/flash_sale', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          flashSaleFileId: item.id
        }
      })

      if (show_confirm) {
        await this.m__get_flash_sale_files()
        this.ntf_s(this.$t('base.delete_success'))
      }
    },

    m__show_flash_sale_files_dialog() {
      this.show_dialog.flash_sale_files = true
    },

    async m__back_to_list(reload, edit_id) {
      this.current_component = 'list'

      if (reload) {
        await Promise.all([
          this.m__update_time_range('range_0')
        ])
      }
    },

    m__go_to_edit(edit_id) {
      if (edit_id) {
        const found = this.flash_sale_list.find(i => i.flash_sale_id === edit_id)
        if (found) this.m__show_edit_component(found)
      }
    },

    async m__update_time_range(range_key) {
      if (this[range_key] && this[range_key].length === 2) {
        this.start_time = this.dayjs(this[range_key][0]).startOf('d').unix()
        this.end_time = this.dayjs(this[range_key][1]).endOf('d').unix()
      } else {
        this.start_time = ''
        this.end_time = ''
      }

      this.loading.get_flash_sale = true
      await this.m__get_flash_sale()
      this.loading.get_flash_sale = false
    },

    async m__update_tab() {
      // if (this.tab === '4') {
      //   return
      // }
      //
      // const range_key = `range_${this.tab}`
      // if (this[range_key] && this[range_key].length === 2) {
      //   this.start_time = this.dayjs(this[range_key][0]).startOf('d').unix()
      //   this.end_time = this.dayjs(this[range_key][1]).endOf('d').unix()
      // } else {
      //   this.start_time = ''
      //   this.end_time = ''
      // }
      //
      // this.loading.get_flash_sale = true
      // await this.m__get_flash_sale()
      // this.loading.get_flash_sale = false
    },

    async m__initial_view() {
      const items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            this.selected_shop = items[0]
            const shop = items[0]

            // todo: check role
            if (!this.check_role(shop, 'marketing', 'flash_sale')) {
              this.shopee_shop.selected = ''
              return
            }

            this.shop = shop
            this.seller = await this.init_seller(shop)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              this.flash_sale_list = []
              return
            }

            this.is_destroyed = false
            this.loading.get_flash_sale = true
            await Promise.all([
              this.m__get_flash_sale_metrics(),
              this.m__get_flash_sale(),
              this.m__get_product(null, true),
              this.m__get_flash_sale_files(),
              this.m__get_flash_sale_advanced_files()
            ])

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
        this.loading.get_flash_sale = false
      }
    },

    async m__get_balance() {
      const response = await this.seller.marketing_get_balance()
      this.balance = response.data.balance
    },

    async m__get_flash_sale() {
      this.loading.get_flash_sale = true
      this.flash_sale_list = []

      try {
        let offset = 0, limit = 20
        let response = await this.seller.flash_sale_get_list(offset, limit, 0, this.start_time, this.end_time)
        for (const item of response.data.flash_sale_list) {
          item.checked = false
          item.gmv = 0
          item.orders = 0
          item.product_impression = 0
          item.product_clicks = 0
          item.product_ctr = 0
          item.loaded = false
        }
        let promotion_id_list = response.data.flash_sale_list.map(i => i.flash_sale_id).join(',')
        if (promotion_id_list) {
          const report_response = await this.seller.flash_sale_get_report(promotion_id_list)
          for (const report of report_response.data) {
            const item = response.data.flash_sale_list.find(i => i.flash_sale_id === report.promotionid)
            if (item) {
              item.click_cnt = report.click_cnt
              item.remindme_cnt = report.remindme_cnt
            }
          }
        }
        this.flash_sale_list.push(...response.data.flash_sale_list)
        // this.m__update_flash_sale_gmv().catch(console.error)

        while (response.data.flash_sale_list && response.data.flash_sale_list.length > 0) {
          offset += limit
          response = await this.seller.flash_sale_get_list(offset, limit, 0, this.start_time, this.end_time)
          for (const item of response.data.flash_sale_list) {
            item.checked = false
            item.gmv = 0
            item.orders = 0
            item.product_impression = 0
            item.product_clicks = 0
            item.product_ctr = 0
            item.loaded = false
          }
          promotion_id_list = response.data.flash_sale_list.map(i => i.flash_sale_id).join(',')
          if (promotion_id_list) {
            const report_response = await this.seller.flash_sale_get_report(promotion_id_list)
            for (const report of report_response.data) {
              const item = response.data.flash_sale_list.find(i => i.flash_sale_id === report.promotionid)
              if (item) {
                item.click_cnt = report.click_cnt
                item.remindme_cnt = report.remindme_cnt
              }
            }
          }
          this.flash_sale_list.push(...response.data.flash_sale_list)
        }

        this.m__update_flash_sale_gmv().catch(console.error)
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_flash_sale = false
      }
    },

    m__get_time(row) {
      return `${this.dayjs(row.start_time * 1000).format('HH:mm DD-MM-YYYY')} - ${this.dayjs(row.end_time * 1000).format('HH:mm')}`
    },

    async m__copy_flash_sale(flash_sale) {
      this.show_dialog.copy_flash_sale_selection = true
      this.flash_sale_selected = flash_sale
      // await this.m__show_create_flash_sale_dialog(flash_sale.flash_sale_id)
    },

    async m__confirm_copy_flash_sale() {
      await this.m__show_create_flash_sale_dialog(this.flash_sale_selected.flash_sale_id)
      this.show_dialog.copy_flash_sale_selection = false
    },

    async m__show_create_flash_sale_dialog(from = null) {
      this.time_slot_list = []
      this.time_slot_group = []

      this.copy_from_id = from

      if (!this.shopee_shop.selected) {
        this.ntf_w(this.$t('required.shop'))
        return
      }

      let count = 0, max_count = 5
      while (!this.seller) {
        await this.sleep(1000)

        if (count++ >= max_count) break
      }

      this.loading.time_slot = true

      const start_time = this.dayjs().unix()
      const end_time = this.dayjs().add(30, 'd').unix()
      const time_slot_resp = await this.seller.flash_sale_get_time_slot(start_time, end_time)
      for (const item of time_slot_resp.data) {
        item.checked = false
        item.can_check = true
      }
      this.time_slot_list = time_slot_resp.data

      this.value = new Date()
      this.time_slot_group = this.time_slot_list.reduce((result, item) => {
        const found = result.find(i => i.date === this.dayjs(item.start_time * 1000).format('DD-MM-YYYY'))
        if (found) {
          found.data.push(item)
        } else {
          result.push({
            date: this.dayjs(item.start_time * 1000).format('DD-MM-YYYY'),
            data: [item]
          })
        }
        return result
      }, [])

      if (this.copy_selection_radio === '2' && from) {
        for (const slot of this.time_slot_group) {
          for (const item of slot.data) {
            if (this.dayjs(item.start_time * 1000).format('HH:mm') === this.dayjs(this.flash_sale_selected.start_time * 1000).format('HH:mm') &&
              this.dayjs(item.end_time * 1000).format('HH:mm') === this.dayjs(this.flash_sale_selected.end_time * 1000).format('HH:mm')) {
              item.checked = true
            }
          }
        }
      }

      this.show_dialog.create_flash_sale = true
      this.loading.time_slot = false
    },

    m__is_in_time_slot(date) {
      for (const time of this.time_slot_list) {
        if (this.dayjs(time.start_time * 1000).isSame(this.dayjs(date), 'day')) {
          return true
        }
      }
      return false
    },

    m__time_slot_number(date) {
      let count = 0

      for (const time of this.time_slot_list) {
        if (this.dayjs(time.start_time * 1000).isSame(this.dayjs(date), 'day')) {
          count++
        }
      }

      return count
    },

    m__format_time_slot(data) {
      return `${this.dayjs(data.start_time * 1000).format('HH:mm:ss')} - ${this.dayjs((data.end_time) * 1000).format('HH:mm:ss')}`
    },

    m__time_slot_change() {
      // if (this.time_slot_list.find(i => i.checked)) {
      //   this.time_slot_list.forEach(i => {
      //     i.can_check = true
      //   })
      //
      //   for (const item1 of this.time_slot_list) {
      //     if (item1.checked) {
      //       for (const item2 of this.time_slot_list) {
      //         if (item1.start_time === item2.start_time) {
      //           continue
      //         }
      //         if (item1.start_time - item2.end_time < 90000 && item2.start_time - item1.end_time < 90000) {
      //           item2.can_check = false
      //         }
      //       }
      //     }
      //   }
      // } else {
      //   this.time_slot_list.forEach(i => {
      //     i.can_check = true
      //   })
      // }
      //
      // this.time_slot_group = this.time_slot_list.reduce((result, item) => {
      //   const date = result.find(i => i.date === this.dayjs(item.start_time * 1000).format('DD-MM-YYYY'))
      //   if (date) {
      //     date.data.push(item)
      //   } else {
      //     result.push({
      //       date: this.dayjs(item.start_time * 1000).format('DD-MM-YYYY'),
      //       data: [item]
      //     })
      //   }
      //   return result
      // }, [])
    },

    async m__confirm_create_flash_sale() {
      this.flash_sale_created = []
      this.time_slot_selected = this.time_slot_list.filter(i => i.checked)
      if (!this.time_slot_selected.length) {
        this.ntf_w(this.$t('required.time_slot'))
        return
      }

      this.loading.confirm_create = true
      for (const time_slot of _uniqBy(this.time_slot_selected, i => `${i.start_time}-${i.end_time}`)) {
        console.log(time_slot)
        const resp = await this.seller.flash_sale_create(time_slot.timeslot_id)
        this.flash_sale_created.push(resp.data)
      }

      this.current_component = 'create'
      this.loading.confirm_create = false
      this.show_dialog.create_flash_sale = false
    },

    async m__delete_flash_sale(flash_sale) {
      try {
        await this.$confirm(this.$t('flash_sale.delete_confirm'), this.$t('base.attention'), {
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel'),
          type: 'warning'
        })

        await this.seller.flash_sale_delete(flash_sale.flash_sale_id, flash_sale.timeslot_id)

        const start_time = this.dayjs().unix()
        const end_time = this.dayjs().add(30, 'd').unix()
        await this.seller.flash_sale_get_time_slot(start_time, end_time)

        this.flash_sale_list = this.flash_sale_list.filter(i => i.flash_sale_id !== flash_sale.flash_sale_id)
        this.ntf_s(this.$t('base.delete_success'))
      } catch (e) {
      }
    },

    m__show_edit_component(item) {
      this.flash_sale_selected = item
      this.current_component = 'edit'
    },

    m__show_detail_component(item) {
      this.flash_sale_selected = item
      this.current_component = 'detail'
    },

    m__show_data_component(item) {
      this.flash_sale_selected = item
      this.current_component = 'data'
    }
  }
}
</script>

<style lang="scss">
.shopee-tag__information.default {
  color: #ee4d2d;
  background-color: #fff1f0
}

.shopee-tag__information.warn {
  color: #eda500;
  background-color: #fff7e0
}

.shopee-tag__information.info {
  color: #40d0bd;
  background-color: #e8f9f7
}

.shopee-tag__information.success {
  color: #5c7;
  background-color: #eaf9ef
}

.shopee-tag__information.error {
  color: #ff4742;
  background-color: #ffe9e8
}

.shopee-tag__information.invalid {
  color: #666;
  background-color: #eee
}

.shopee-tag__information.return {
  color: #ff831d;
  background-color: #feece1
}

.shopee-tag__information {
  line-height: 18px;
  border-style: none;
  border-radius: 2px;
}

.shopee-tag {
  position: relative;
  display: inline-block;
  height: 18px;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 500;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid transparent;
  border-right: 0;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

#date-picker-data-center {
  height: 33px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/flash_sale/index.vue